<template>
  <div class="chat-page" :class="{ 'chat-desktop-mode': desktopMode }">
    <!-- SVG 气泡尾巴 & 勾号定义 -->
    <svg style="position:absolute;width:0;height:0;overflow:hidden">
      <defs>
        <symbol id="message-tail-filled" viewBox="0 0 11 20">
          <g transform="translate(9 -14)" fill="inherit" fill-rule="evenodd">
            <path d="M-6 16h6v17c-.193-2.84-.876-5.767-2.05-8.782-.904-2.325-2.446-4.485-4.625-6.48A1 1 0 01-6 16z" fill="inherit"/>
          </g>
        </symbol>
        <!-- 单勾/双勾改用 tgico 字体图标 -->
      </defs>
    </svg>
    <!-- 会话列表视图 - 始终存在 -->
    <div class="session-list-view" :class="{ 'behind': currentSession && !desktopMode }">
      <div class="chat-header">
        <h2>在线 {{ onlineSessionCount }}/{{ sessions.length }}</h2>
        <div class="header-actions">
          <button v-if="isAdmin" class="clear-images-btn" @click="showImageStats">
            🖼️
          </button>
        </div>
      </div>
      
      <!-- 图片管理弹窗 -->
      <div v-if="showImageModal" class="modal-overlay" @click.self="showImageModal = false">
        <div class="modal-content">
          <h3>聊天图片管理</h3>
          <div class="image-stats">
            <p>图片数量: <strong>{{ imageStats.count }}</strong> 张</p>
            <p>占用空间: <strong>{{ imageStats.totalSizeMB }}</strong> MB</p>
          </div>
          <div class="modal-actions">
            <button class="btn-danger" @click="clearAllImages" :disabled="clearingImages">
              {{ clearingImages ? '清除中...' : '清除所有图片' }}
            </button>
            <button class="btn-cancel" @click="showImageModal = false">关闭</button>
          </div>
        </div>
      </div>

      <!-- 会话列表 -->
      <div class="session-list" v-if="sessions.length > 0">
        <div
          v-for="session in sortedSessions"
          :key="session.sessionKey"
          class="session-item"
          :class="{ 'pinned': session.isPinned }"
          @click="openSession(session)"
        >
          <!-- 头像 -->
          <div class="session-avatar-wrapper">
            <div class="session-avatar" :style="{ backgroundColor: getPlatformColor(session.platform) }">
              <img v-if="session.platform === '螃蟹' || session.platform === '螃蟹聊天室'" src="@/assets/px.png" class="avatar-img" />
              <img v-else-if="session.platform === '氪金兽'" src="@/pages/uploads/kjs.jpg" class="avatar-img" />
              <img v-else-if="session.platform === '闲鱼'" src="@/assets/xy.jpg" class="avatar-img" />
              <img v-else-if="session.platform === '转转'" src="@/assets/zz.png" class="avatar-img" />
              <img v-else-if="session.platform === '盼之' || session.platform === '盼之聊天室'" src="@/assets/pz.jpg" class="avatar-img" />
              <img v-else-if="session.platform === '交易猫'" src="@/assets/jym.png" class="avatar-img" />
              <img v-else-if="session.platform === '银联'" src="/NaiLong-CF4UoRtq-NaiLong.ico" class="avatar-img" />
              <img v-else-if="session.platform === '微信'" src="@/assets/wx.webp" class="avatar-img" />
              <img v-else-if="session.platform === '千岛'" src="@/assets/qd-service-avatar.png" class="avatar-img" />
              <span v-else>{{ session.platform || '客户' }}</span>
            </div>
            <!-- 聊天室角标 -->
            <div v-if="session.platform === '螃蟹聊天室' || session.platform === '盼之聊天室'" class="chatroom-badge">
              <svg viewBox="0 0 1024 1024" width="16" height="16"><path d="M511.999488 4.375657c-280.361339 0-507.624343 227.263004-507.624342 507.624343 0 280.347013 227.264027 507.625366 507.624342 507.625366 280.347013 0 507.624343-227.278353 507.624343-507.625366 0-280.361339-227.27733-507.624343-507.624343-507.624343zM145.450185 575.657832v-17.128099c0-2.078335 0.330528-4.158716 1.019213-6.18384 5.577019-15.835663 36.422538-54.543244 99.063203-63.383585-0.205685-0.37146-0.454348-0.757247-0.701988-1.143033-13.192464-10.616802-24.332175-25.047466-32.608675-42.081421-13.301957-3.429099-24.579815-16.400528-28.696576-33.392528-4.5312-18.603707 0.150426-36.257785 11.621688-45.220924-0.055259-63.260789 36.256762-109.060905 105.327884-109.060905 59.199287 0 85.47165 39.74112 85.47165 39.741119a174.735673 174.735673 0 0 0-18.892279 17.061585c-30.184463 31.575136-46.998407 72.747861-50.110281 122.540917-18.300808 24.001647-24.676006 57.83522-16.193821 91.778286 7.324826 29.331026 24.593118 53.414537 47.342238 67.40518l-181.463911 0.083911c-11.691273-0.001023-21.178345-9.448186-21.178345-21.016663z m592.201623 174.36012c0 16.372899-13.797237 29.743418-30.79026 29.743418H317.219293c-17.019629 0-30.831192-13.370519-30.831192-29.743418v-24.249287c0-2.933819 0.481977-5.879917 1.472537-8.744152 8.138354-22.405289 53.015448-77.196173 144.187937-89.698928a24.228821 24.228821 0 0 0-1.033539-1.62501c-19.181875-15.009855-35.403325-35.429931-47.451732-59.555397-19.346627-4.846378-35.760458-23.216771-41.764196-47.259351-6.582929-26.328645 0.220011-51.294247 16.923438-64.003709-0.041956-46.446845 13.054317-83.695191 38.914288-110.74015 34.466999-36.036751 81.230046-43.596937 114.388237-43.596938 33.145911 0 79.908958 7.560186 114.375957 43.596938 25.859971 27.031657 38.928614 64.278979 38.928615 110.753453 16.690124 12.710486 23.478737 37.661761 16.937764 63.990406-6.045693 24.069185-22.487154 42.452881-41.778522 47.259351-12.187577 24.331151-28.54615 44.87607-47.53462 59.611679-0.330528 0.535189-0.688685 1.044796-0.963954 1.568728 91.185792 12.447497 136.131447 67.51672 144.064116 89.381703 1.101077 3.15383 1.597381 6.127558 1.597381 9.061377v24.249287z m119.717616-153.37211l-181.449586-0.056282c22.706141-13.976316 39.989783-38.017872 47.328935-67.364247 8.454556-33.998325 2.066055-67.817572-16.180517-91.804892-3.139503-49.848315-19.966751-91.02104-50.123584-122.55422-9.983375-10.258645-15.449877-13.894452-19.304672-16.978697a92.042299 92.042299 0 0 1 7.339152-8.991791c23.684422-25.460882 55.81112-30.804586 78.57252-30.804587 22.775726 0 54.901401 5.342682 78.57252 30.804587 17.763572 19.098987 26.755364 45.413306 26.726711 78.241992 11.485589 8.964162 16.153912 26.603915 11.622712 45.207621-4.116761 16.991999-15.395642 29.963429-28.683273 33.392528-8.275477 17.033955-19.416212 31.451316-32.594349 42.068118-0.261966 0.399089-0.49528 0.77055-0.716314 1.143033 62.626339 8.840342 93.472881 47.547923 99.0499 63.371306 0.688685 2.036379 1.01819 4.103458 1.01819 6.181793v17.130145c0 11.565407-9.487072 21.013593-21.178345 21.013593z" fill="#13227a"></path></svg>
            </div>
            <!-- 在线状态点（非聊天室时显示） -->
            <div v-else-if="session.isOnline" class="online-dot"></div>
          </div>
          
          <!-- 会话信息 -->
          <div class="session-info">
            <div class="session-header">
              <span class="session-name">{{ session.note || getSessionDisplayId(session) }}</span>
              <span class="session-time">{{ formatTime(session.lastMessageTime) }}</span>
            </div>
            <div class="session-preview">
              <span class="preview-text">{{ session.lastMessage || '暂无消息' }}</span>
              <div class="preview-right">
                <span v-if="session.isPinned" class="pin-icon">
                  <svg viewBox="0 0 1025 1024" width="16" height="16"><path d="M320 839.68l-238.592 174.08c-8.704 6.656-19.456 9.728-29.696 9.728-12.8 0-26.112-5.12-35.84-14.848-17.92-17.92-20.48-46.08-5.12-66.56l212.992-288.256L56.32 487.424C39.936 471.04 36.864 445.44 48.128 425.472c8.192-12.8 76.8-112.64 229.376-75.264 2.56 0.512 5.12 0.512 8.192 1.024 6.144 0.512 13.312 1.024 20.992 2.56 32.256 5.12 89.6-20.48 139.264-62.976 47.616-40.448 78.336-87.552 78.336-120.32 0-7.68 0-15.872-0.512-23.552-1.024-30.72-3.072-77.824 31.744-112.64 41.472-41.472 107.52-45.056 153.088-7.68 1.024 0.512 1.536 1.536 2.56 2.56 24.576 24.064 276.48 275.968 279.04 278.528 21.504 21.504 33.792 50.688 33.792 81.408s-11.776 59.392-33.792 80.896c-34.816 34.816-82.432 33.28-113.664 31.744-7.168 0-15.36-0.512-23.04-0.512-30.72 0-67.584 21.504-103.936 60.928-50.688 55.296-81.92 126.464-79.36 158.72 1.024 10.24 3.072 28.16 3.584 30.72 36.864 149.504-62.976 217.6-74.752 225.28-20.48 12.288-46.592 9.216-62.976-7.168l-165.376-165.376-50.688 35.328z" fill="#707070"></path></svg>
                </span>
                <span v-if="mutedSessions.has(session.sessionKey)" class="mute-icon" title="免打扰">
                  <svg viewBox="0 0 1131 1024" width="14" height="14"><path d="M914.688 892.736L64 236.224l38.784-50.88L271.36 315.648a300.288 300.288 0 0 1 246.976-157.952v-33.28c0-16.64 13.504-30.08 30.08-30.08h2.304c16.576 0 30.08 13.44 30.08 30.08v32.96a299.776 299.776 0 0 1 284.928 299.136v294.272l45.504 58.624 48.768 37.696-45.312 45.632zM234.624 480.384l506.88 391.232H140.416l94.272-121.536-0.064-269.696z" fill="#999"/></svg>
                </span>
                <span v-if="session.unreadCount" class="unread-badge" :class="{ 'muted-badge': mutedSessions.has(session.sessionKey) }">{{ session.unreadCount }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 加载状态 -->
      <div v-if="isLoadingSessions" class="loading-state">
        <div class="loading-spinner"></div>
        <p>加载对话列表中...</p>
      </div>

      <!-- 空状态 - 显示空白 -->
      <div v-else-if="sessions.length === 0" class="empty-state">
        <p>暂无对话</p>
      </div>
    </div>

    <!-- 聊天详情视图 - 覆盖层，带滑动动画 -->
    <transition :name="desktopMode ? '' : 'slide-chat-detail'">
    <div v-if="currentSession" class="chat-detail-view telegram-style" :class="{ 'desktop-detail': desktopMode }">
      <!-- 渐变背景Canvas -->
      <canvas ref="gradientCanvas" class="gradient-bg-canvas"></canvas>
      <!-- 聊天头部 - 简洁白色顶栏 -->
      <div class="detail-header goofish-header">
        <div class="gf-back" @click="closeSession"
          v-motion="{ initial: { opacity: 0, x: -20 }, animate: { opacity: 1, x: 0 }, transition: { type: 'spring', stiffness: 300, damping: 24, delay: 0.05 } }">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span v-if="totalUnreadCount" class="gf-back-count">{{ totalUnreadCount }}</span>
        </div>
        <div class="gf-center-info"
          v-motion="{ initial: { opacity: 0, y: -16 }, animate: { opacity: 1, y: 0 }, transition: { type: 'spring', stiffness: 280, damping: 22, delay: 0.1 } }">
          <div class="gf-name">{{ sessionNote || currentSession.customerName || currentSession.senderIp }}</div>
          <div class="gf-status">
            <span :class="{ 'gf-online': currentSession.isOnline }">
              {{ currentSession.isOnline ? '在线' : '离线' }}
            </span>
          </div>
        </div>
        <div class="gf-header-actions">
          <div class="gf-action-btn" @click="toggleMuteSession" :title="currentSession && mutedSessions.has(currentSession.sessionKey) ? '取消免打扰' : '消息免打扰'">
            <svg viewBox="0 0 1131 1024" width="32" height="32" :fill="currentSession && mutedSessions.has(currentSession.sessionKey) ? '#4caf50' : '#8a8a8a'"><path d="M914.688 892.736L64 236.224l38.784-50.88L271.36 315.648a300.288 300.288 0 0 1 246.976-157.952v-33.28c0-16.64 13.504-30.08 30.08-30.08h2.304c16.576 0 30.08 13.44 30.08 30.08v32.96a299.776 299.776 0 0 1 284.928 299.136v294.272l45.504 58.624 48.768 37.696-45.312 45.632zM234.624 480.384l506.88 391.232H140.416l94.272-121.536-0.064-269.696z"/></svg>
          </div>
          <div class="gf-action-btn" @click="showChatSettings = true" title="聊天设置">
            <svg viewBox="0 0 1024 1024" width="25" height="25"><path d="M758.722706 194.015785c27.265994 0 49.344848-21.36561 49.344848-47.698349L808.067554 50.918693c0-26.349111-22.078855-47.713698-49.344848-47.713698-27.267017 0-49.346895 21.364587-49.346895 47.713698l0 95.398744C709.377858 172.650175 731.457736 194.015785 758.722706 194.015785z" fill="#8a8a8a"/><path d="M265.275247 194.015785c27.267017 0 49.345871-21.36561 49.345871-47.698349L314.621119 50.918693c0-26.349111-22.078855-47.713698-49.345871-47.713698-27.265994 0-49.343825 21.364587-49.343825 47.713698l0 95.398744C215.932446 172.650175 238.0113 194.015785 265.275247 194.015785z" fill="#8a8a8a"/><path d="M939.642219 98.617042l-82.229816 0 0 47.698349c0 52.667523-44.188408 95.398744-98.688673 95.398744s-98.686626-42.73122-98.686626-95.398744L660.037103 98.617042l-49.344848 0-3.291976 0c0-1.11745-40.900525 0-95.40079 0s-95.39772 0.496304-95.39772 0l-3.294023 0-49.344848 0 0 47.698349c0 52.667523-44.155662 95.398744-98.68765 95.398744-54.499242 0-98.688673-42.73122-98.688673-95.398744L166.586574 98.617042 84.356758 98.617042c-27.265994 0-49.345871 21.366633-49.345871 47.698349l0 826.77922c0 26.333762 22.079878 47.699372 49.345871 47.699372l855.287507 0c27.265994 0 49.344848-21.36561 49.344848-47.699372L988.989113 146.31539C988.987067 119.983675 966.907189 98.617042 939.642219 98.617042zM725.817272 861.794711 298.180681 861.794711c-19.682271 0-35.643802-15.96153-35.643802-35.633568 0-19.684318 15.96153-35.645848 35.643802-35.645848l427.635567 0c19.684318 0 35.645848 15.96153 35.645848 35.645848C761.46312 845.833181 745.50159 861.794711 725.817272 861.794711zM725.817272 677.599595 298.180681 677.599595c-19.682271 0-35.643802-15.96153-35.643802-35.633568 0-19.684318 15.96153-35.645848 35.643802-35.645848l427.635567 0c19.684318 0 35.645848 15.96153 35.645848 35.645848C761.46312 661.638065 745.50159 677.599595 725.817272 677.599595zM725.817272 493.40448 298.180681 493.40448c-19.682271 0-35.643802-15.962553-35.643802-35.634592 0-19.683295 15.96153-35.643802 35.643802-35.643802l427.635567 0c19.684318 0 35.645848 15.960507 35.645848 35.643802C761.46312 477.44295 745.50159 493.40448 725.817272 493.40448z" fill="#8a8a8a"/></svg>
          </div>
          <div class="gf-action-btn" @click="clearChatHistory" title="清空聊天记录">
            <svg viewBox="0 0 1024 1024" width="28" height="28"><path d="M777.429333 838.101333c20.352-38.528 40.192-82.645333 52.906667-127.146666 17.536-61.354667 23.893333-118.954667 25.685333-162.901334l-66.218666-66.218666-247.637334-247.637334-66.218666-66.218666c-43.946667 1.792-101.546667 8.106667-162.858667 25.685333-44.586667 12.714667-88.661333 32.554667-127.189333 52.906667C89.6 297.386667 60.885333 414.293333 106.538667 503.765333l0.554666 1.066667 29.866667 49.066667a995.754667 995.754667 0 0 0 333.141333 333.184l49.066667 29.824 1.066667 0.554666c89.429333 45.653333 206.378667 16.896 257.194666-79.36z" fill="#8a8a8a"/><path d="M929.066667 141.354667a32.853333 32.853333 0 0 0-46.421334-46.421334L811.178667 166.4a208.085333 208.085333 0 0 0-243.968 0l47.317333 47.317333 195.754667 195.754667 47.317333 47.317333a208.085333 208.085333 0 0 0 0-243.968l71.466667-71.466666z" fill="#8a8a8a"/><rect x="558" y="168" width="56" height="56" rx="8" fill="#8a8a8a" transform="rotate(45 586 196)"/></svg>
          </div>
        </div>
      </div>
      <!-- 聊天设置弹窗 -->
      <transition name="settings-popup">
      <div v-if="showChatSettings" class="chat-settings-overlay" @click.self="showChatSettings = false">
        <div class="chat-settings-panel">
          <div class="settings-list">
            <div class="settings-item" @click="togglePinSession">
              <span>{{ currentSession.isPinned ? '取消置顶' : '置顶聊天' }}</span>
            </div>
            <div class="settings-item" @click="openNoteEditor">
              <span>备注</span>
            </div>
            <div class="settings-item" @click="toggleMuteSession">
              <span>{{ currentSession && mutedSessions.has(currentSession.sessionKey) ? '取消免打扰' : '消息免打扰' }}</span>
            </div>
            <div class="settings-item settings-cancel" @click="showChatSettings = false">
              <span>取消</span>
            </div>
          </div>
        </div>
      </div>
      </transition>

      <!-- 备注编辑弹窗 -->
      <transition name="settings-popup">
      <div v-if="showNoteEditor" class="chat-settings-overlay" @click.self="showNoteEditor = false">
        <div class="note-editor-panel">
          <div class="settings-header">
            <span>编辑备注</span>
            <div class="close-btn" @click="showNoteEditor = false">×</div>
          </div>
          <div class="note-editor-body">
            <textarea
              v-model="noteInput"
              placeholder="输入备注内容..."
              class="note-textarea"
              maxlength="200"
            ></textarea>
            <div class="note-actions">
              <span class="note-count">{{ noteInput.length }}/200</span>
              <button class="note-save-btn" @click="saveNote">保存</button>
            </div>
          </div>
        </div>
      </div>
      </transition>

      <!-- 聊天消息列表 -->
      <div class="messages-container" ref="messagesContainer">
        <!-- 日期分隔符和消息 -->
        <template v-for="(message, index) in messages" :key="message.id">
          <!-- 日期分隔符 -->
          <div v-if="shouldShowDateSeparator(message, index)" class="date-separator">
            <span class="date-text">{{ formatDateSeparator(message.createdAt) }}</span>
          </div>
          <div :class="['message', { 'message-slide-in': message.isNew, 'first-in-group': isFirstInGroup(index), 'last-in-group': isLastInGroup(index) }, message.speakerType === 1 ? 'customer' : 'agent']" @animationend="message.isNew = false">
          <!-- 买家消息 (speakerType=1) - 显示在左边 -->
          <template v-if="message.speakerType === 1">
            <div class="message-avatar customer-avatar" :style="{ backgroundColor: getPlatformColor(currentSession.platform) }">
              <img v-if="currentSession.platform === '螃蟹' || currentSession.platform === '螃蟹聊天室'" src="@/assets/px.png" class="avatar-img" />
              <img v-else-if="currentSession.platform === '氪金兽'" src="@/pages/uploads/kjs.jpg" class="avatar-img" />
              <img v-else-if="currentSession.platform === '闲鱼'" src="@/assets/xy.jpg" class="avatar-img" />
              <img v-else-if="currentSession.platform === '转转'" src="@/assets/zz.png" class="avatar-img" />
              <img v-else-if="currentSession.platform === '盼之' || currentSession.platform === '盼之聊天室'" src="@/assets/pz.jpg" class="avatar-img" />
              <img v-else-if="currentSession.platform === '交易猫'" src="@/assets/jym.png" class="avatar-img" />
              <img v-else-if="currentSession.platform === '银联'" src="/NaiLong-CF4UoRtq-NaiLong.ico" class="avatar-img" />
              <img v-else-if="currentSession.platform === '微信'" src="@/assets/wx.webp" class="avatar-img" />
              <img v-else-if="currentSession.platform === '千岛'" src="@/assets/qd-service-avatar.png" class="avatar-img" />
              <span v-else>{{ currentSession.platform || '客' }}</span>
            </div>
            <div class="message-content">
              <!-- 订单卡片 -->
              <div class="order-card-msg" v-if="isOrderMessage(message.content)">
                <div class="order-card-inner">
                  <img class="order-card-img" :src="parseOrderMessage(message.content)?.image" :alt="parseOrderMessage(message.content)?.title">
                  <div class="order-card-body">
                    <div class="order-card-detail">
                      <h4 class="order-card-name">{{ parseOrderMessage(message.content)?.title }}</h4>
                      <div class="order-card-price-wrap">
                        <span class="order-card-currency">¥</span>
                        <span class="order-card-price">{{ parseOrderMessage(message.content)?.price }}</span>
                        <span class="order-card-count">×1</span>
                      </div>
                    </div>
                    <span class="order-card-status">交易中 ›</span>
                  </div>
                </div>
              </div>
              <!-- 链接卡片 -->
              <div class="link-card-msg" v-else-if="isLinkCardMessage(message.content)">
                <div class="link-card-inner">
                  <h4 class="link-card-title">{{ parseLinkCardMessage(message.content)?.title }}</h4>
                  <div class="link-card-btn" @click.stop="openCardLink(parseLinkCardMessage(message.content)?.link)">{{ parseLinkCardMessage(message.content)?.btnText || '查看详情' }}</div>
                </div>
              </div>
              <div class="message-bubble customer" v-else-if="!isImageMessage(message.content)">{{ formatContent(message.content) }}</div>
              <img v-else :src="getImageUrl(message.content)" class="message-image" referrerpolicy="no-referrer" @click="previewImage(message.content)" />
              <div class="message-meta">
                <span>{{ formatMessageTime(message.createdAt) }}</span>
                <span v-if="message.senderIp" class="ip-info">IP: {{ message.senderIp }}</span>
              </div>
            </div>
          </template>
          <!-- 客服消息 (speakerType=2) 和 模拟买家消息 (speakerType=3) - 都显示在右边 -->
          <template v-else>
            <div class="message-content agent-content">
              <!-- 订单卡片 -->
              <div class="order-card-msg agent-order-card" v-if="isOrderMessage(message.content)">
                <div class="order-card-inner">
                  <img class="order-card-img" :src="parseOrderMessage(message.content)?.image" :alt="parseOrderMessage(message.content)?.title">
                  <div class="order-card-body">
                    <div class="order-card-detail">
                      <h4 class="order-card-name">{{ parseOrderMessage(message.content)?.title }}</h4>
                      <div class="order-card-price-wrap">
                        <span class="order-card-currency">¥</span>
                        <span class="order-card-price">{{ parseOrderMessage(message.content)?.price }}</span>
                        <span class="order-card-count">×1</span>
                      </div>
                    </div>
                    <span class="order-card-status">交易中 ›</span>
                  </div>
                </div>
              </div>
              <!-- 链接卡片 -->
              <div class="link-card-msg agent-link-card" v-else-if="isLinkCardMessage(message.content)">
                <div class="link-card-inner">
                  <h4 class="link-card-title">{{ parseLinkCardMessage(message.content)?.title }}</h4>
                  <div class="link-card-btn" @click.stop="openCardLink(parseLinkCardMessage(message.content)?.link)">{{ parseLinkCardMessage(message.content)?.btnText || '查看详情' }}</div>
                </div>
              </div>
              <div class="message-bubble agent" :class="{ 'buyer-mode': message.speakerType === 3, 'has-tail': isLastInGroup(index), 'send-failed': message.sendFailed }" v-else-if="!isImageMessage(message.content)">
                <div class="bubble-message-text">
                  <span v-if="message.speakerType === 3" class="role-tag">卖家</span>
                  {{ formatContent(message.content) }}<span class="bubble-time"><span class="bubble-time-text">{{ formatMessageTime(message.createdAt) }}</span><span v-if="!message.sendFailed" class="tgico read-status" :class="[message.isRead ? 'tgico-checks is-read' : 'tgico-check']"></span><span v-if="message.sendFailed" class="send-failed-icon" title="发送失败，点击重发" @click="resendMessage(message)">⚠</span></span><span class="clearfix"></span>
                </div>
                <svg v-if="isLastInGroup(index)" viewBox="0 0 11 20" width="11" height="20" class="bubble-tail"><use href="#message-tail-filled"></use></svg>
              </div>
              <img v-else :src="getImageUrl(message.content)" class="message-image agent-image" :class="{ 'send-failed': message.sendFailed }" referrerpolicy="no-referrer" @click="previewImage(message.content)" />
              <div v-if="isImageMessage(message.content) || isOrderMessage(message.content) || isLinkCardMessage(message.content)" class="message-meta">
                <span v-if="message.sendFailed" class="send-failed-icon" title="发送失败，点击重发" @click="resendMessage(message)">⚠</span>
                {{ formatMessageTime(message.createdAt) }}
              </div>
            </div>
          </template>
        </div>
        </template>
      </div>

      <!-- 输入区域 -->
      <!-- 悬浮工具栏：在渐变背景上 -->
      <div class="floating-toolbar">
        <div class="tool-chip" @click="triggerImageUpload" :class="{ 'uploading': isUploading }">
          <svg v-if="!isUploading" width="24" height="24" viewBox="80 220 870 620"><path d="M754 257.2H270.2c-85.5 0-155 69.5-155 155v263.4c0 85.5 69.5 155 155 155H754c85.5 0 155-69.5 155-155V412.2c0-85.4-69.5-155-155-155z m-483.8 60H754c52.4 0 95 42.6 95 95v193.4L728.4 424c-5.4-8.1-14.4-13.1-24.2-13.4-9.8-0.3-19 4.2-24.9 12L505.1 656.1 335.1 544c-10.5-6.9-24.1-6.6-34.3 0.9L175.2 637V412.2c0-52.4 42.6-95 95-95zM754 770.6H270.2c-41.2 0-76.4-26.4-89.5-63.2l138.8-101.8 176.2 116.2c5.1 3.3 10.8 5 16.5 5 9.2 0 18.2-4.2 24.1-12.1l165.7-222 141.9 213.7c-12.8 37.3-48.3 64.2-89.9 64.2z" fill="#707070"/><path d="M428.1 387.1m-30.8 0a30.8 30.8 0 1 0 61.6 0 30.8 30.8 0 1 0-61.6 0Z" fill="#707070"/><path d="M597.9 387.1m-30.8 0a30.8 30.8 0 1 0 61.6 0 30.8 30.8 0 1 0-61.6 0Z" fill="#707070"/><path d="M557.7 438.2c0 25.1-20.4 45.9-45.5 45.4-24.2-0.5-43.7-20.3-43.7-44.6l-0.2-3.3c-0.3-5 3.7-9.3 8.8-9.3H549c4.9 0 8.8 3.9 8.8 8.8v3z" fill="#707070"/></svg>
          <span v-else class="upload-spinner"></span>
          <span>照片</span>
        </div>
        <div class="tool-chip" @click="openPhrasesPanel">
          <svg width="24" height="24" viewBox="200 130 650 780">
            <!-- 左上半 黑色 -->
            <path d="M553.02 429.96V203.4c0-16.99-13.77-30.77-30.76-30.77-10.29 0-19.89 5.14-25.6 13.7L256.74 546.21c-9.42 14.14-5.6 33.24 8.54 42.67a30.744 30.744 0 0 0 17.06 5.17h188.64z" fill="#2E3133"/>
            <!-- 右下半 灰色 -->
            <path d="M470.98 594.05V820.6c0 16.99 13.77 30.77 30.76 30.77 10.29 0 19.9-5.14 25.6-13.7l239.92-359.88c9.42-14.14 5.6-33.25-8.55-42.67a30.702 30.702 0 0 0-17.05-5.16H553.02z" fill="#B0B3B8"/>
          </svg>
          <span>话术</span>
        </div>
        <div class="tool-chip" @click="openCardsPanel">
          <svg width="24" height="24" viewBox="0 0 1024 1024">
            <path d="M578.048 138.688c78.464 0 140.032 0 188.608 5.44 49.6 5.632 89.856 17.28 123.264 43.712 9.984 7.872 19.264 16.64 27.712 26.048 28.416 31.936 41.088 70.528 47.168 117.952 0.64 5.44 1.024 8.192 0.384 10.56a13.12 13.12 0 0 1-7.552 8.704c-2.304 0.896-5.184 0.896-10.944 0.896H77.312c-5.76 0-8.64 0-10.88-0.896a13.056 13.056 0 0 1-7.68-8.704 29.888 29.888 0 0 1 0.448-10.56c6.016-47.36 18.752-86.016 47.168-117.952a218.88 218.88 0 0 1 27.712-26.048c33.408-26.432 73.6-38.08 123.2-43.712 48.64-5.44 110.208-5.44 188.672-5.44h132.096z m392.64 375.552c0 73.6 0 131.84-5.888 177.92-6.08 47.36-18.752 86.016-47.168 117.888a219.2 219.2 0 0 1-27.712 26.112c-33.408 26.432-73.6 38.08-123.2 43.712-48.64 5.44-110.208 5.44-188.672 5.44H445.952c-78.464 0-140.096 0-188.672-5.44-49.536-5.632-89.792-17.28-123.2-43.712a219.072 219.072 0 0 1-27.712-26.112c-28.416-31.872-41.152-70.464-47.168-117.888-5.888-46.08-5.888-104.32-5.888-177.92v-4.48c0-24.576 0-47.424 0.256-68.736 0.128-11.712 0.128-17.6 3.84-21.312 3.84-3.712 9.728-3.712 21.568-3.712h866.048c11.84 0 17.728 0 21.504 3.712 3.712 3.712 3.84 9.6 3.904 21.312 0.256 21.312 0.256 44.16 0.256 68.672v4.544z m-533.376 168.448a32 32 0 0 0 32 32h64a32 32 0 1 0 0-64h-64a32 32 0 0 0-32 32z m224-32a32 32 0 1 0 0 64h149.376a32 32 0 1 0 0-64h-149.376z" fill="#707070"/>
          </svg>
          <span>卡片</span>
        </div>
        <!-- 聊天室：切换身份 -->
        <div
          v-if="isChatRoom"
          class="tool-chip"
          :class="{ 'seller-mode': currentSpeakerType === 3 }"
          @click="toggleSpeakerType"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
          </svg>
          <span>{{ currentSpeakerType === 2 ? '客服' : '卖家' }}</span>
        </div>
      </div>
      <input
        type="file"
        accept="image/*"
        style="display: none;"
        ref="imageInput"
        @change="handleImageUpload"
      />

      <!-- 底部白色输入栏 -->
      <div class="input-area">
        <div class="input-box-wrapper">
          <input
            v-model="inputMessage"
            class="message-input"
            placeholder="输入消息, 回车发送..."
            @keypress.enter="sendMessage"
          />
        </div>
      </div>

      <!-- 话术面板 -->
      <div v-if="showPhrasesPanel" class="phrases-overlay" :class="{ closing: phrasesPanelClosing }" @click.self="closePhrasesPanel">
        <div class="phrases-panel" :class="{ closing: phrasesPanelClosing }">
          <div class="phrases-header">
            <span>快捷话术</span>
            <div class="close-btn" @click="closePhrasesPanel">×</div>
          </div>
          <!-- 分类标签 -->
          <div class="phrases-tabs">
            <div 
              v-for="category in Object.keys(phrasesCategories)" 
              :key="category"
              class="phrases-tab"
              :class="{ active: activePhrasesCategory === category }"
              @click="activePhrasesCategory = category"
            >
              {{ category }}
            </div>
          </div>
          <!-- 自定义话术添加区域 -->
          <div v-if="activePhrasesCategory === '自定义'" class="custom-phrase-input">
            <input 
              v-model="customPhraseInput" 
              placeholder="输入自定义话术..."
              @keypress.enter="addCustomPhrase"
            />
            <button @click="addCustomPhrase" :disabled="!customPhraseInput.trim()">添加</button>
          </div>
          <div class="phrases-list">
            <div 
              v-for="(phrase, index) in phrasesCategories[activePhrasesCategory]" 
              :key="activePhrasesCategory === '自定义' ? phrase.id : index"
              class="phrase-item"
              @click="sendPhrase(activePhrasesCategory === '自定义' ? phrase.content : phrase)"
            >
              <span>{{ activePhrasesCategory === '自定义' ? phrase.content : phrase }}</span>
              <span v-if="activePhrasesCategory === '自定义'" class="delete-phrase" @click.stop="deleteCustomPhrase(index)">×</span>
            </div>
            <div v-if="activePhrasesCategory === '自定义' && phrasesCategories['自定义'].length === 0" class="empty-phrases">
              暂无自定义话术，请添加
            </div>
          </div>
        </div>
      </div>

      <!-- 卡片面板 -->
      <div v-if="showCardsPanel" class="phrases-overlay" :class="{ closing: cardsPanelClosing }" @click.self="closeCardsPanel">
        <div class="phrases-panel" :class="{ closing: cardsPanelClosing }">
          <div class="phrases-header">
            <span>卡片</span>
            <div class="close-btn" @click="closeCardsPanel">×</div>
          </div>
          <!-- 添加卡片区域 -->
          <div class="card-add-area">
            <input
              v-model="cardTitleInput"
              class="card-input"
              placeholder="输入卡片标题..."
            />
            <input
              v-model="cardLinkInput"
              class="card-input"
              placeholder="输入链接地址..."
            />
            <input
              v-model="cardBtnTextInput"
              class="card-input"
              placeholder="输入按钮文字（如：立即查看）"
              @keypress.enter="saveCard"
            />
            <button class="card-save-btn" @click="saveCard" :disabled="!cardTitleInput.trim() || !cardLinkInput.trim()">保存</button>
          </div>
          <!-- 已保存的卡片列表 -->
          <div class="phrases-list">
            <div
              v-for="(card, index) in savedCards"
              :key="card.id || index"
              class="card-item"
              @click="sendCard(card)"
            >
              <div class="card-item-content">
                <div class="card-item-title">{{ card.title }}</div>
                <div class="card-item-btn-text">{{ card.btnText || '查看详情' }}</div>
              </div>
              <span class="delete-phrase" @click.stop="deleteCard(index)">×</span>
            </div>
            <div v-if="savedCards.length === 0" class="empty-phrases">
              暂无卡片，请添加标题和链接
            </div>
          </div>
        </div>
      </div>
    </div>
    </transition>

    <!-- 桌面端：常驻话术侧栏（第四栏） -->
    <div v-if="desktopMode && currentSession" class="desktop-phrases-sidebar">
      <div class="phrases-header">
        <span>快捷话术</span>
      </div>
      <!-- 分类标签 -->
      <div class="phrases-tabs">
        <div
          v-for="category in Object.keys(phrasesCategories)"
          :key="'desktop-' + category"
          class="phrases-tab"
          :class="{ active: activePhrasesCategory === category }"
          @click="activePhrasesCategory = category"
        >
          {{ category }}
        </div>
      </div>
      <!-- 自定义话术添加区域 -->
      <div v-if="activePhrasesCategory === '自定义'" class="custom-phrase-input">
        <input
          v-model="customPhraseInput"
          placeholder="输入自定义话术..."
          @keypress.enter="addCustomPhrase"
        />
        <button @click="addCustomPhrase" :disabled="!customPhraseInput.trim()">添加</button>
      </div>
      <div class="phrases-list">
        <div
          v-for="(phrase, index) in phrasesCategories[activePhrasesCategory]"
          :key="'desktop-' + (activePhrasesCategory === '自定义' ? phrase.id : index)"
          class="phrase-item"
          @click="sendPhrase(activePhrasesCategory === '自定义' ? phrase.content : phrase)"
        >
          <span>{{ activePhrasesCategory === '自定义' ? phrase.content : phrase }}</span>
          <span v-if="activePhrasesCategory === '自定义'" class="delete-phrase" @click.stop="deleteCustomPhrase(index)">×</span>
        </div>
        <div v-if="activePhrasesCategory === '自定义' && phrasesCategories['自定义'].length === 0" class="empty-phrases">
          暂无自定义话术，请添加
        </div>
      </div>
    </div>

    <!-- 桌面端：无会话时的占位 -->
    <div v-if="desktopMode && !currentSession" class="desktop-no-session">
      <div class="no-session-content">
        <svg viewBox="0 0 24 24" width="64" height="64" fill="none" stroke="#ccc" stroke-width="1">
          <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"></path>
        </svg>
        <p>选择一个对话开始聊天</p>
      </div>
    </div>

    <!-- 图片预览模态框 -->
    <div class="image-preview-modal" :class="{ active: imagePreviewVisible }" @click.self="closeImagePreview">
      <img class="image-preview-content" :src="previewImageUrl" alt="预览图片">
    </div>
  </div>
</template>

<script>
import { apiFetch, API_BASE_URL } from '@/config/api'
import { chatWebSocket } from '@/utils/websocket'
import { escapeHtml, isSafeImageUrl } from '@/utils/xssProtection'
import ChatBackgroundGradientRenderer from '@/utils/gradientRenderer'

// Emoji 转换映射表
const emojiMap = {
  '😀': '[笑脸]', '😃': '[大笑]', '😄': '[开心]', '😁': '[嘻嘻]', '😆': '[哈哈]',
  '😅': '[尴尬笑]', '🤣': '[笑哭]', '😂': '[笑哭]', '🙂': '[微笑]', '🙃': '[倒脸]',
  '😉': '[眨眼]', '😊': '[害羞]', '😇': '[天使]', '🥰': '[喜欢]', '😍': '[花痴]',
  '🤩': '[好棒]', '😘': '[飞吻]', '😗': '[亲亲]', '😚': '[亲亲]', '😙': '[亲亲]',
  '🥲': '[含泪笑]', '😋': '[好吃]', '😛': '[吐舌]', '😜': '[调皮]', '🤪': '[滑稽]',
  '😝': '[吐舌闭眼]', '🤑': '[发财]', '🤗': '[抱抱]', '🤭': '[捂嘴笑]', '🤫': '[嘘]',
  '🤔': '[思考]', '🤐': '[闭嘴]', '🤨': '[疑问]', '😐': '[无语]', '😑': '[无语]',
  '😶': '[沉默]', '😏': '[得意]', '😒': '[不屑]', '🙄': '[白眼]', '😬': '[龇牙]',
  '🤥': '[说谎]', '😌': '[舒适]', '😔': '[沮丧]', '😪': '[困]', '🤤': '[流口水]',
  '😴': '[睡觉]', '😷': '[口罩]', '🤒': '[发烧]', '🤕': '[受伤]', '🤢': '[恶心]',
  '🤮': '[呕吐]', '🤧': '[打喷嚏]', '🥵': '[热]', '🥶': '[冷]', '🥴': '[晕]',
  '😵': '[晕]', '🤯': '[爆炸]', '🤠': '[牛仔]', '🥳': '[庆祝]', '🥸': '[伪装]',
  '😎': '[墨镜]', '🤓': '[书呆子]', '🧐': '[单片眼镜]', '😕': '[困惑]', '😟': '[担心]',
  '🙁': '[不开心]', '😮': '[惊讶]', '😯': '[惊讶]', '😲': '[震惊]', '😳': '[脸红]',
  '🥺': '[可怜]', '😦': '[惊愕]', '😧': '[痛苦]', '😨': '[害怕]', '😰': '[焦虑]',
  '😥': '[失望]', '😢': '[哭]', '😭': '[大哭]', '😱': '[吓死]', '😖': '[困扰]',
  '😣': '[坚持]', '😞': '[失望]', '😓': '[汗]', '😩': '[疲惫]', '😫': '[累]',
  '🥱': '[打哈欠]', '😤': '[生气]', '😡': '[愤怒]', '😠': '[生气]', '🤬': '[骂人]',
  '😈': '[小恶魔]', '👿': '[恶魔]', '💀': '[骷髅]', '☠️': '[骷髅]', '💩': '[便便]',
  '🤡': '[小丑]', '👹': '[妖怪]', '👺': '[天狗]', '👻': '[幽灵]', '👽': '[外星人]',
  '👾': '[怪物]', '🤖': '[机器人]', '😺': '[猫笑]', '😸': '[猫开心]', '😹': '[猫笑哭]',
  '😻': '[猫花痴]', '😼': '[猫得意]', '😽': '[猫亲亲]', '🙀': '[猫惊讶]', '😿': '[猫哭]',
  '😾': '[猫生气]', '🙈': '[不看]', '🙉': '[不听]', '🙊': '[不说]', '💋': '[唇印]',
  '💌': '[情书]', '💘': '[丘比特]', '💝': '[礼物心]', '💖': '[闪亮心]', '💗': '[心跳]',
  '💓': '[心动]', '💞': '[旋转心]', '💕': '[双心]', '💟': '[心]', '❣️': '[心叹号]',
  '💔': '[心碎]', '❤️': '[红心]', '🧡': '[橙心]', '💛': '[黄心]', '💚': '[绿心]',
  '💙': '[蓝心]', '💜': '[紫心]', '🖤': '[黑心]', '🤍': '[白心]', '🤎': '[棕心]',
  '💯': '[100分]', '💢': '[生气]', '💥': '[爆炸]', '💫': '[头晕]', '💦': '[汗水]',
  '💨': '[跑]', '🕳️': '[洞]', '💣': '[炸弹]', '💬': '[对话]', '👁️‍🗨️': '[看]',
  '🗨️': '[说话]', '🗯️': '[愤怒说]', '💭': '[想]', '💤': '[睡]', '👋': '[挥手]',
  '🤚': '[手背]', '🖐️': '[张开手]', '✋': '[停]', '🖖': '[祝福]', '👌': '[OK]',
  '🤌': '[捏]', '🤏': '[一点点]', '✌️': '[耶]', '🤞': '[祈祷]', '🤟': '[爱你]',
  '🤘': '[摇滚]', '🤙': '[打电话]', '👈': '[向左]', '👉': '[向右]', '👆': '[向上]',
  '🖕': '[中指]', '👇': '[向下]', '☝️': '[指上]', '👍': '[赞]', '👎': '[踩]',
  '✊': '[拳头]', '👊': '[出拳]', '🤛': '[左拳]', '🤜': '[右拳]', '👏': '[鼓掌]',
  '🙌': '[举手]', '👐': '[张开手]', '🤲': '[合掌]', '🤝': '[握手]', '🙏': '[祈祷]',
  '✍️': '[写字]', '💅': '[美甲]', '🤳': '[自拍]', '💪': '[肌肉]', '🦾': '[机械臂]',
  '🦿': '[机械腿]', '🦵': '[腿]', '🦶': '[脚]', '👂': '[耳朵]', '🦻': '[助听器]',
  '👃': '[鼻子]', '🧠': '[大脑]', '👀': '[眼睛]', '👁️': '[眼睛]', '👅': '[舌头]',
  '👄': '[嘴唇]', '🔥': '[火]', '⭐': '[星星]', '🌟': '[闪星]', '✨': '[闪闪]',
  '🎉': '[庆祝]', '🎊': '[彩带]', '🎁': '[礼物]', '🎈': '[气球]', '🎂': '[蛋糕]',
  '🍰': '[蛋糕]', '☀️': '[太阳]', '🌈': '[彩虹]', '☁️': '[云]', '⛈️': '[雷雨]',
  '❄️': '[雪花]', '🌸': '[樱花]', '🌹': '[玫瑰]', '🌺': '[花]', '🌻': '[向日葵]',
  '🍀': '[四叶草]', '🍎': '[苹果]', '🍊': '[橘子]', '🍋': '[柠檬]', '🍇': '[葡萄]',
  '🍓': '[草莓]', '🍑': '[桃子]', '🍒': '[樱桃]', '🥝': '[猕猴桃]', '🍌': '[香蕉]',
  '🍉': '[西瓜]', '🍔': '[汉堡]', '🍕': '[披萨]', '🍟': '[薯条]', '🌭': '[热狗]',
  '🍿': '[爆米花]', '🥤': '[饮料]', '☕': '[咖啡]', '🍵': '[茶]', '🍺': '[啤酒]',
  '🍷': '[红酒]', '🥂': '[干杯]', '⚽': '[足球]', '🏀': '[篮球]', '🎮': '[游戏]',
  '🎲': '[骰子]', '🎯': '[靶心]', '🏆': '[奖杯]', '🥇': '[金牌]', '🥈': '[银牌]',
  '🥉': '[铜牌]', '🚗': '[汽车]', '✈️': '[飞机]', '🚀': '[火箭]', '⏰': '[闹钟]',
  '📱': '[手机]', '💻': '[电脑]', '📷': '[相机]', '🔑': '[钥匙]', '💰': '[钱袋]',
  '💵': '[美元]', '💴': '[日元]', '💶': '[欧元]', '💷': '[英镑]', '💎': '[钻石]',
  '✅': '[对勾]', '❌': '[错误]', '❓': '[问号]', '❗': '[感叹号]', '⚠️': '[警告]'
}

// 反向映射（文字转emoji）
const reverseEmojiMap = Object.fromEntries(
  Object.entries(emojiMap).map(([k, v]) => [v, k])
)

// emoji转文字
const emojiToText = (text) => {
  if (!text) return text
  let result = text
  for (const [emoji, name] of Object.entries(emojiMap)) {
    result = result.split(emoji).join(name)
  }
  return result
}

// 文字转emoji
const textToEmoji = (text) => {
  if (!text) return text
  let result = text
  for (const [name, emoji] of Object.entries(reverseEmojiMap)) {
    result = result.split(name).join(emoji)
  }
  return result
}

export default {
  name: 'ChatPage',
  props: {
    desktopMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      sessions: [],
      currentSession: null,
      messages: [],
      inputMessage: '',
      lastMessageId: 0,
      isAgentOnline: true,
      agentAccount: '',
      pollingInterval: null,
      sessionPollingInterval: null,
      agentHeartbeatInterval: null,
      quickReplies: [
        '您好，有什么可以帮您？',
        '请稍等，正在为您处理',
        '好的，已收到',
        '感谢您的支持！'
      ],
      // 图片上传相关
      isUploading: false,
      isAdmin: false,
      showImageModal: false,
      imageStats: { count: 0, totalSizeMB: '0.00' },
      clearingImages: false,
      // 螃蟹聊天室：身份切换 (2=客服, 3=卖家)
      currentSpeakerType: 2,
      // 聊天设置
      showChatSettings: false,
      // 备注功能
      showNoteEditor: false,
      sessionNote: '',
      noteInput: '',
      // 图片预览
      imagePreviewVisible: false,
      previewImageUrl: '',
      // 话术面板
      showPhrasesPanel: false,
      phrasesPanelClosing: false,
      // 卡片面板
      showCardsPanel: false,
      cardsPanelClosing: false,
      cardTitleInput: '',
      cardLinkInput: '',
      cardBtnTextInput: '',
      savedCards: [],
      activePhrasesCategory: '预设',
      phrasesCategories: {
        '预设': [
          '您好，亲亲~请问您是要出售游戏账号吗？',
          '您好！欢迎来到本平台交易，我是您的专属客服。非常感谢您选择我们平台来进行游戏账号的交易。在这里，我们致力于为您提供安全、可靠、高效的服务体验。',
          '向您介绍一下我们平台的担保交易服务。作为专业的游戏账号中介，我们深知安全性和信任度是买家和卖家最为关心的问题。因此，我们推出了担保交易服务，旨在为您的交易提供全方位的保障。在担保交易模式下，买家支付资金将由我们平台进行暂时托管。随后，我们的专业团队将对交易账号进行严格的审核和验证，确保账号信息的真实性和合法性。一旦账号审核通过，我们将协助您完成账号的转移工作。双方确保无误后我们才会将交易资金打款给卖家，从而确保双方权益得到充分保障。通过我们的担保交易服务，您可以享受到更加安心、便捷的交易体验。我们承诺，将始终秉承诚信、专业、高效的服务理念，为您的游戏账号交易之路保驾护航。',
          '这边开始发货，请您提供一下账号密码开始哦亲，感谢您的配合~',
          '亲亲，请您这边提供一下所需的验证码呢',
          '亲您好欢迎使用此平台进行交易，请您配合我开始发货吧，任何疑问可随时提出哦~',
          '请您稍等~',
          '在交易过程中，我们将对账号进行严格的审核和验证，确保账号的真实性和合法性。交易完成后，我们将及时通知您，并协助您完成账号的转移和交接工作。',
          '我们平台提供担保交易服务，确保您的交易资金安全无忧。在交易过程中，我们将全程监控，一旦发现任何异常行为，将立即采取措施保障您的权益。',
          '关于您提出的问题，我们已经了解并会尽快核实处理，请您耐心等待。',
          '如果您在交易过程中遇到任何困难或疑问，请随时联系我们，我们将竭诚为您解答。',
          '请您不要着急，我们一定会竭尽全力帮您解决问题，确保您的交易顺利进行。',
          '为了确保交易的安全性，我们需要您提供一些身份验证信息，请您放心，这些信息将严格保密。',
          '我们的交易流程非常简便快捷，您只需按照页面提示填写相关信息，选择交易方式，即可完成交易。',
          '本次交易已完成，祝您生活愉快~'
        ],
        '自定义': []
      },
      customPhraseInput: '',
      // 会话ID映射（用于生成随机显示ID）
      sessionIdMap: {},
      // 置顶状态是否已加载
      pinnedLoaded: false,
      // 免打扰会话列表（sessionKey集合）
      mutedSessions: new Set(),
      // WebSocket 取消订阅函数
      wsUnsubscribe: null,
      // 加载状态
      isLoadingSessions: true,
      // 渐变背景渲染器
      gradientRenderer: null,
      gradientAnimInterval: null
    }
  },
  watch: {
    currentSession(val) {
      if (val) {
        this.$nextTick(() => this.initGradientBackground())
      } else {
        this.cleanupGradientBackground()
      }
    }
  },
  mounted() {
    this.loadAgentInfo()
    this.loadMutedSessions()
    this.loadSessions().then(() => {
      // 会话列表加载完成后再建立 WebSocket 连接
      this.connectGlobalWebSocket()
    })
    this.startSessionPolling()
    this.updateAgentOnlineStatusFull(true)
    this.startAgentHeartbeat()
    this.loadCustomPhrases()
    this.loadSavedCards()

    // 监听页面可见性变化（客服切回页面时重新同步）
    this._handleVisibilityChange = () => {
      if (!document.hidden) {
        console.log('客服页面恢复可见，重新同步...')
        // 1. 重新上报在线
        this.updateAgentOnlineStatusFull(true)
        // 2. 检查 WebSocket，不活就强制重连
        if (!chatWebSocket.isConnected()) {
          console.log('WebSocket 已断开，强制重连...')
          chatWebSocket.forceReconnect()
          if (this.currentSession) {
            setTimeout(() => this.connectWebSocket(), 1000)
          }
        }
        // 3. 刷新会话列表
        this.loadSessions()
        // 4. 如果有打开的会话，立即拉取最新消息
        if (this.currentSession) {
          this.pollNewMessages()
          this.refreshReadStatus()
          // 恢复消息轮询
          if (!this.pollingInterval) this.startMessagePolling()
        }
        // 5. 恢复心跳
        if (!this.agentHeartbeatInterval) this.startAgentHeartbeat()
      } else {
        // 页面隐藏时暂停高频轮询，节省服务器资源
        // 保留 sessionPolling（30秒一次，很轻量）
        // 保留心跳（2秒纯内存，极轻量，停掉会导致6秒后被判离线）
        console.log('客服页面隐藏，暂停高频轮询（心跳保持）')
        this.stopMessagePolling()
      }
    }
    document.addEventListener('visibilitychange', this._handleVisibilityChange)
  },
  beforeUnmount() {
    this.stopPolling()
    this.disconnectWebSocket() // 断开 WebSocket
    this.updateAgentOnlineStatusFull(false)
    this.cleanupGradientBackground()
    // 移除 visibilitychange 监听
    if (this._handleVisibilityChange) {
      document.removeEventListener('visibilitychange', this._handleVisibilityChange)
    }
  },
  computed: {
    // 所有会话未读消息总数（免打扰的会话不计入）
    totalUnreadCount() {
      return this.sessions.reduce((sum, s) => {
        if (this.mutedSessions.has(s.sessionKey)) return sum
        return sum + (s.unreadCount || 0)
      }, 0)
    },
    // 判断当前会话是否是螃蟹聊天室
    isPx2ChatRoom() {
      return this.currentSession && this.currentSession.platform === '螃蟹聊天室'
    },
    // 判断当前会话是否是盼之聊天室
    isPz2ChatRoom() {
      return this.currentSession && this.currentSession.platform === '盼之聊天室'
    },
    // 判断当前会话是否是聊天室（螃蟹或盼之）
    isChatRoom() {
      return this.isPx2ChatRoom || this.isPz2ChatRoom
    },
    // 在线会话数量
    onlineSessionCount() {
      return this.sessions.filter(s => s.isOnline).length
    },
    // 排序后的会话列表（置顶的在前面）
    sortedSessions() {
      return [...this.sessions].sort((a, b) => {
        // 置顶的优先
        if (a.isPinned && !b.isPinned) return -1
        if (!a.isPinned && b.isPinned) return 1
        // 然后按最新消息时间排序（最新的在前面）
        const timeA = a.lastMessageTime ? new Date(a.lastMessageTime).getTime() : 0
        const timeB = b.lastMessageTime ? new Date(b.lastMessageTime).getTime() : 0
        return timeB - timeA
      })
    },
    // 安全的会话标题（防止XSS）
    safeSessionTitle() {
      if (!this.currentSession) return ''
      const title = this.currentSession.senderIp || this.currentSession.customerName || ''
      return escapeHtml(title)
    },
    // 安全的会话备注（防止XSS）
    safeSessionNote() {
      return this.sessionNote ? escapeHtml(this.sessionNote) : ''
    }
  },
  methods: {
    // 消息分组判断
    isFirstInGroup(index) {
      if (index === 0) return true
      const prev = this.messages[index - 1]
      const curr = this.messages[index]
      if (!prev || prev.speakerType !== curr.speakerType) return true
      if (this.shouldShowDateSeparator(curr, index)) return true
      return false
    },
    isLastInGroup(index) {
      if (index === this.messages.length - 1) return true
      const next = this.messages[index + 1]
      const curr = this.messages[index]
      if (!next || next.speakerType !== curr.speakerType) return true
      if (this.shouldShowDateSeparator(next, index + 1)) return true
      return false
    },
    // 初始化渐变背景
    initGradientBackground() {
      this.cleanupGradientBackground()
      const canvas = this.$refs.gradientCanvas
      if (!canvas) return
      canvas.setAttribute('data-colors', '#dbddbb,#6ba587,#d5d88d,#88b884')
      const renderer = new ChatBackgroundGradientRenderer()
      renderer.init(canvas)
      renderer.startAnimation()
      this.gradientRenderer = renderer
    },
    // 清理渐变背景
    cleanupGradientBackground() {
      if (this.gradientRenderer) {
        this.gradientRenderer.cleanup()
        this.gradientRenderer = null
      }
    },
    // 切换免打扰状态
    toggleMuteSession() {
      if (!this.currentSession) return
      const key = this.currentSession.sessionKey
      const newSet = new Set(this.mutedSessions)
      if (newSet.has(key)) {
        newSet.delete(key)
        this.mutedSessions = newSet
        this.saveMutedSessions()
        this.showChatSettings = false
        alert('已关闭免打扰')
      } else {
        newSet.add(key)
        this.mutedSessions = newSet
        this.saveMutedSessions()
        this.showChatSettings = false
        alert('已开启免打扰')
      }
    },
    // 判断会话是否免打扰
    isSessionMuted(sessionKey) {
      return sessionKey && this.mutedSessions.has(sessionKey)
    },
    // 从 localStorage 加载免打扰列表
    loadMutedSessions() {
      try {
        const saved = localStorage.getItem(`mutedSessions_${this.agentAccount}`)
        if (saved) {
          this.mutedSessions = new Set(JSON.parse(saved))
        }
      } catch (e) {
        console.log('加载免打扰列表失败:', e)
      }
    },
    // 保存免打扰列表到 localStorage
    saveMutedSessions() {
      try {
        localStorage.setItem(
          `mutedSessions_${this.agentAccount}`,
          JSON.stringify([...this.mutedSessions])
        )
      } catch (e) {
        console.log('保存免打扰列表失败:', e)
      }
    },
    // 打开备注编辑器
    openNoteEditor() {
      this.noteInput = this.sessionNote || ''
      this.showNoteEditor = true
      this.showChatSettings = false
    },
    // 保存备注
    async saveNote() {
      if (!this.currentSession?.sessionKey) return
      try {
        const res = await apiFetch('/api/chat/session/note', {
          method: 'POST',
          body: JSON.stringify({
            sessionKey: this.currentSession.sessionKey,
            note: this.noteInput
          })
        })
        if (res.code === 0) {
          this.sessionNote = this.noteInput
          this.showNoteEditor = false
        } else {
          alert(res.msg || '保存失败')
        }
      } catch (e) {
        alert('保存失败')
      }
    },
    // 加载会话备注
    async loadSessionNote() {
      if (!this.currentSession?.sessionKey) return
      try {
        const res = await apiFetch(`/api/chat/session/note?sessionKey=${encodeURIComponent(this.currentSession.sessionKey)}`)
        if (res.code === 0) {
          this.sessionNote = res.data || ''
        }
      } catch (e) {
        console.log('加载备注失败', e)
      }
    },
    // 切换发送身份（客服/卖家）
    toggleSpeakerType() {
      this.currentSpeakerType = this.currentSpeakerType === 2 ? 3 : 2
    },
    // 加载客服信息
    loadAgentInfo() {
      try {
        const user = JSON.parse(localStorage.getItem('user'))
        if (user) {
          this.agentAccount = user.account || user.username || 'admin'
          this.isAdmin = user.role === 'admin'
        }
      } catch (e) {
        console.error('获取客服信息失败:', e)
        this.agentAccount = 'admin'
        this.isAdmin = false
      }
    },

    // 加载会话列表
    async loadSessions() {
      this.isLoadingSessions = true
      try {
        const response = await apiFetch(`/api/chat/sessions?agentAccount=${encodeURIComponent(this.agentAccount)}`)
        if (response.code === 0 && response.data) {
          // 保存当前的置顶状态
          const currentPinnedKeys = this.sessions
            .filter(s => s.isPinned)
            .map(s => s.sessionKey)

          // 处理会话数据，使用后端返回的平台信息
          this.sessions = response.data.map(session => {
            const inferredCode = this.inferPlatformCodeFromCustomerName(session.customerName)
            const backendCode = session.platform
            const normalizedCode = (!backendCode || backendCode === 'xy' || backendCode === '闲鱼')
              ? inferredCode
              : backendCode
            return {
              ...session,
              // 将后端的平台标识转换为中文名称
              platform: this.convertPlatformCode(normalizedCode),
              senderIp: session.senderIp || this.extractIpFromSession(session),
              // 保留已有的置顶状态
              isPinned: currentPinnedKeys.includes(session.sessionKey)
            }
          })
          // 首次加载时从数据库获取置顶状态
          if (currentPinnedKeys.length === 0 && !this.pinnedLoaded) {
            this.pinnedLoaded = true
            this.loadPinnedSessions()
          }
        }
      } catch (error) {
        console.error('加载会话列表失败:', error)
      } finally {
        this.isLoadingSessions = false
      }
    },

    // 将后端平台标识转换为中文名称
    convertPlatformCode(code) {
      const platformMap = {
        'kjs': '氪金兽',
        'xy': '闲鱼',
        'zz': '转转',
        'px': '螃蟹',
        'pz': '盼之',
        'jym': '交易猫',
        'wx': '微信',
        'yl': '银联',
        'qd': '千岛'
      }
      return platformMap[code] || code || '闲鱼'
    },

    // 按客户名前缀推断平台标识（与各客服页前缀规则一致）
    inferPlatformCodeFromCustomerName(customerName) {
      if (!customerName) return 'xy'
      if (customerName.startsWith('kjs_') || customerName.startsWith('kjs')) return 'kjs'
      if (customerName.startsWith('zz_')) return 'zz'
      if (customerName.startsWith('px2_')) return 'px2'
      if (customerName.startsWith('px_')) return 'px'
      if (customerName.startsWith('pz2_')) return 'pz2'
      if (customerName.startsWith('pz_')) return 'pz'
      if (customerName.startsWith('jym_')) return 'jym'
      if (customerName.startsWith('yl_')) return 'yl'
      if (customerName.startsWith('wx_')) return 'wx'
      if (customerName.startsWith('qd_')) return 'qd'
      return 'xy'
    },

    // 检测平台类型（从后端返回的platform字段获取）
    // eslint-disable-next-line no-unused-vars
    detectPlatform(sessionKey, backendPlatform) {
      // 优先使用后端返回的平台信息
      if (backendPlatform) {
        return this.convertPlatformCode(backendPlatform)
      }
      // 默认返回闲鱼
      return '闲鱼'
    },

    // 从会话中提取IP
    extractIpFromSession(session) {
      // 如果会话中有最新消息的IP，使用它
      return session.lastSenderIp || ''
    },

    // 获取平台颜色
    getPlatformColor(platform) {
      const colors = {
        '氪金兽': '#EA4C89',
        '闲鱼': '#FFE60D',
        '转转': '#FF483C',  // 转转红色
        '微信': '#07C160',
        '支付宝': '#1677FF',
        '螃蟹': '#FF8C00',  // 橙色
        '盼之': '#722ED1',
        '交易猫': '#FA8C16',
        '银联': '#C41D7F',
        '千岛': '#8B5CF6'   // 千岛紫色
      }
      return colors[platform] || '#666'
    },

    // 获取会话显示ID（8位随机字母数字）
    getSessionDisplayId(session) {
      // 使用sessionKey生成固定的随机ID，确保同一会话显示相同ID
      if (!session || !session.sessionKey) return ''
      
      if (!this.sessionIdMap[session.sessionKey]) {
        const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789'
        let result = ''
        // 使用sessionKey作为种子生成伪随机
        let seed = 0
        for (let i = 0; i < session.sessionKey.length; i++) {
          seed += session.sessionKey.charCodeAt(i)
        }
        for (let i = 0; i < 8; i++) {
          seed = (seed * 9301 + 49297) % 233280
          result += chars[Math.floor((seed / 233280) * chars.length)]
        }
        this.sessionIdMap[session.sessionKey] = result
      }
      return this.sessionIdMap[session.sessionKey]
    },

    // 打开会话
    async openSession(session) {
      this.currentSession = session
      // 清除该会话的未读计数
      const idx = this.sessions.indexOf(session)
      if (idx !== -1 && this.sessions[idx].unreadCount) {
        this.sessions = this.sessions.map((s, i) => i === idx ? { ...s, unreadCount: 0 } : s)
      }
      this.messages = []
      this.lastMessageId = 0
      this.sessionNote = ''
      await this.loadMessages()
      this.loadSessionNote()
      this.startMessagePolling()
      this.connectWebSocket() // 连接 WebSocket

      // 确保消息渲染完成后再滚动到底部
      this.$nextTick(() => {
        setTimeout(() => {
          this.scrollToBottom()
        }, 100)
      })
    },

    // 关闭会话
    closeSession() {
      this.stopMessagePolling()
      this.disconnectWebSocket() // 断开 WebSocket
      this.currentSession = null
      this.messages = []
      this.loadSessions() // 刷新会话列表
      
      // iOS Safari 视口修复 - 强制重新计算布局
      this.$nextTick(() => {
        window.scrollTo(0, 0)
        document.body.style.height = '100%'
        setTimeout(() => {
          document.body.style.height = ''
        }, 50)
      })
    },

    // 加载消息
    async loadMessages() {
      if (!this.currentSession) return
      
      try {
        // 客服端查看消息，viewerType=agent
        const response = await apiFetch(`/api/chat/messages?sessionId=${encodeURIComponent(this.currentSession.sessionKey)}&viewerType=agent`)
        if (response.code === 0 && response.data) {
          this.messages = response.data.map(m => ({ isRead: false, ...m }))
          if (this.messages.length > 0) {
            this.lastMessageId = Math.max(...this.messages.map(m => m.id))
          }
          this.scrollToBottom()
        }
      } catch (error) {
        console.error('加载消息失败:', error)
      }
    },

    // 轮询新消息
    async pollNewMessages() {
      if (!this.currentSession) return

      try {
        const response = await apiFetch(
          `/api/chat/poll?sessionId=${encodeURIComponent(this.currentSession.sessionKey)}&lastId=${this.lastMessageId}`
        )
        if (response.code === 0 && response.data && response.data.length > 0) {
          // 过滤掉已存在的消息（防止重复）
          const existingIds = new Set(this.messages.filter(m => m.id < 1000000000000).map(m => m.id))
          const newMessages = response.data.filter(m => {
            if (existingIds.has(m.id)) return false
            // 检查是否有对应的乐观更新临时消息需要替换
            const tempIdx = this.messages.findIndex(t =>
              t.id > 1000000000000 && t.content === m.content && t.speakerType === m.speakerType
            )
            if (tempIdx !== -1) {
              // 用真实数据替换临时消息
              this.messages[tempIdx].id = m.id
              this.messages[tempIdx].isNew = false
              return false
            }
            return true
          })

          if (newMessages.length > 0) {
            // 标记为新消息，播放动画
            const messagesWithAnimation = newMessages.map(m => ({ isRead: false, ...m, isNew: true }))
            this.messages.push(...messagesWithAnimation)
            this.scrollToBottom()

            // 播放提示音（如果是客户消息且未免打扰）
            const hasCustomerMessage = newMessages.some(m => m.speakerType === 1)
            if (hasCustomerMessage && !this.isSessionMuted(this.currentSession?.sessionKey)) {
              this.playNotificationSound()
            }
          }
          // 始终更新 lastMessageId
          this.lastMessageId = Math.max(this.lastMessageId, ...response.data.map(m => m.id))
        }

      } catch (error) {
        console.log('轮询错误:', error)
      }

      // 轮询刷新已读状态（作为 WebSocket 的兜底）
      this.refreshReadStatus()
    },

    // 刷新已读状态（查询客户的已读位置，更新客服消息的已读标记）
    async refreshReadStatus() {
      if (!this.currentSession) return
      try {
        const res = await apiFetch(
          `/api/chat/read-position?sessionId=${encodeURIComponent(this.currentSession.sessionKey)}&userType=customer`
        )
        if (res.code === 0 && res.data && res.data.lastReadMessageId) {
          const lastReadId = res.data.lastReadMessageId
          let changed = false
          const updated = this.messages.map(msg => {
            if (msg.speakerType !== 1 && msg.id <= lastReadId && !msg.isRead) {
              changed = true
              return { ...msg, isRead: true }
            }
            return msg
          })
          if (changed) this.messages = updated
        }
      } catch (e) {
        // 静默失败
      }
    },

    // 发送消息（客服/卖家身份）
    async sendMessage() {
      const content = this.inputMessage.trim()
      if (!content || !this.currentSession) return

      // 将emoji转换为文字格式存储
      const contentToSend = this.convertEmoji(content)

      // 生成临时ID
      const tempId = Date.now()
      
      // 聊天室使用当前选择的身份，其他平台固定为客服(2)
      const speakerType = this.isChatRoom ? this.currentSpeakerType : 2
      
      // 乐观更新
      const tempMessage = {
        id: tempId,
        sessionKey: this.currentSession.sessionKey,
        agentAccount: this.agentAccount,
        speakerType: speakerType,
        content: contentToSend, // 存储转换后的文字
        customerName: this.currentSession.customerName,
        createdAt: new Date().toISOString(),
        isNew: true, // 标记为新消息，用于控制动画
        isRead: false // 新发送消息默认未读
      }
      this.messages.push(tempMessage)
      this.inputMessage = ''
      this.scrollToBottom()

      // 发送消息时触发渐变加速流动
      if (this.gradientRenderer) {
        this.gradientRenderer.toNextPositionSmooth(800)
      }

      try {
        const response = await apiFetch('/api/chat/send', {
          method: 'POST',
          body: JSON.stringify({
            sessionId: this.currentSession.sessionKey,
            agentAccount: this.agentAccount,
            speakerType: speakerType,
            content: contentToSend, // 发送转换后的文字
            customerName: this.currentSession.customerName,
            platform: this.inferPlatformCodeFromCustomerName(this.currentSession.customerName)
          })
        })

        if (response.code === 0 && response.data && response.data.messageId) {
          // 用真实ID替换临时ID，防止轮询时重复
          const msgIndex = this.messages.findIndex(m => m.id === tempId)
          if (msgIndex !== -1) {
            // 先清除动画标记，再换ID，防止key变化导致动画重播
            this.messages[msgIndex].isNew = false
            this.messages[msgIndex].id = response.data.messageId
          }
          this.lastMessageId = Math.max(this.lastMessageId, response.data.messageId)
          // 发送成功后延迟刷新已读状态
          setTimeout(() => this.refreshReadStatus(), 1000)
          setTimeout(() => this.refreshReadStatus(), 2500)
          // 发送成功后立即触发一次轮询，确保消息同步
          setTimeout(() => this.pollNewMessages(), 500)
        } else {
          // 后端返回错误（限流、权限等），标记发送失败
          console.error('发送失败:', response.msg)
          const failIdx = this.messages.findIndex(m => m.id === tempId)
          if (failIdx !== -1) {
            this.messages = [
              ...this.messages.slice(0, failIdx),
              { ...this.messages[failIdx], sendFailed: true, isNew: false },
              ...this.messages.slice(failIdx + 1)
            ]
          }
        }
      } catch (error) {
        console.error('发送消息失败:', error)
        // 发送失败，标记消息为失败状态
        const failIdx = this.messages.findIndex(m => m.id === tempId)
        if (failIdx !== -1) {
          this.messages = [
            ...this.messages.slice(0, failIdx),
            { ...this.messages[failIdx], sendFailed: true, isNew: false },
            ...this.messages.slice(failIdx + 1)
          ]
        }
      }
    },

    // 重发失败的消息
    async resendMessage(failedMessage) {
      // 移除失败的消息
      this.messages = this.messages.filter(m => m.id !== failedMessage.id)
      // 判断是否是图片消息
      if (this.isImageMessage(failedMessage.content)) {
        await this.sendImageMessage(failedMessage.content)
      } else {
        // 保存当前输入框内容，重发后恢复
        const savedInput = this.inputMessage
        this.inputMessage = failedMessage.content
        await this.sendMessage()
        // 恢复用户原来正在输入的内容
        if (!this.inputMessage) {
          this.inputMessage = savedInput
        }
      }
    },

    // 插入快捷回复
    insertQuickReply(reply) {
      this.inputMessage = reply
    },

    // 打开话术面板（先收起键盘）
    openPhrasesPanel() {
      // 让输入框失去焦点，收起键盘
      document.activeElement?.blur()
      // 延迟显示面板，等待键盘收起
      setTimeout(() => {
        this.showPhrasesPanel = true
      }, 100)
    },

    // 发送话术（直接发送）
    sendPhrase(phrase) {
      this.inputMessage = phrase
      this.closePhrasesPanel()
      this.sendMessage()
    },

    // 关闭话术面板（带动画）
    closePhrasesPanel() {
      this.phrasesPanelClosing = true
      setTimeout(() => {
        this.showPhrasesPanel = false
        this.phrasesPanelClosing = false
      }, 250) // 与动画时长一致
    },

    // 打开卡片面板
    openCardsPanel() {
      document.activeElement?.blur()
      setTimeout(() => {
        this.showCardsPanel = true
      }, 100)
    },

    // 关闭卡片面板（带动画）
    closeCardsPanel() {
      this.cardsPanelClosing = true
      setTimeout(() => {
        this.showCardsPanel = false
        this.cardsPanelClosing = false
      }, 250)
    },

    // 打开卡片链接
    openCardLink(link) {
      if (link) window.open(link, '_blank')
    },

    // 保存卡片
    async saveCard() {
      const title = this.cardTitleInput.trim()
      const link = this.cardLinkInput.trim()
      const btnText = this.cardBtnTextInput.trim() || '查看详情'
      if (!title || !link) return

      try {
        const response = await apiFetch('/api/chat/cards', {
          method: 'POST',
          body: JSON.stringify({
            agentAccount: this.agentAccount,
            title,
            link,
            btnText
          })
        })
        if (response.code === 0 && response.data) {
          this.savedCards.push({
            id: response.data.id,
            title: response.data.title,
            link: response.data.link,
            btnText: response.data.btnText || btnText
          })
        } else {
          // 接口未就绪时走本地存储
          const card = { id: Date.now(), title, link, btnText }
          this.savedCards.push(card)
          this.saveCardsToLocal()
        }
        this.cardTitleInput = ''
        this.cardLinkInput = ''
        this.cardBtnTextInput = ''
      } catch (e) {
        // 降级：本地存储
        const card = { id: Date.now(), title, link, btnText }
        this.savedCards.push(card)
        this.saveCardsToLocal()
        this.cardTitleInput = ''
        this.cardLinkInput = ''
        this.cardBtnTextInput = ''
      }
    },

    // 删除卡片
    async deleteCard(index) {
      const card = this.savedCards[index]
      if (!card) return

      try {
        const response = await apiFetch(`/api/chat/cards/${card.id}`, {
          method: 'DELETE'
        })
        if (response.code === 0) {
          this.savedCards.splice(index, 1)
        } else {
          this.savedCards.splice(index, 1)
          this.saveCardsToLocal()
        }
      } catch (e) {
        this.savedCards.splice(index, 1)
        this.saveCardsToLocal()
      }
    },

    // 点击卡片 → 发送卡片消息
    sendCard(card) {
      const btnText = card.btnText || '查看详情'
      this.inputMessage = `[卡片:${card.title}:${btnText}:${card.link}]`
      this.closeCardsPanel()
      this.sendMessage()
    },

    // 加载卡片列表
    async loadSavedCards() {
      try {
        const response = await apiFetch(`/api/chat/cards?agentAccount=${encodeURIComponent(this.agentAccount)}`)
        if (response.code === 0 && response.data) {
          this.savedCards = response.data
        } else {
          this.loadCardsFromLocal()
        }
      } catch (e) {
        this.loadCardsFromLocal()
      }
    },

    // 本地存储 - 保存
    saveCardsToLocal() {
      localStorage.setItem(`savedCards_${this.agentAccount}`, JSON.stringify(this.savedCards))
    },

    // 本地存储 - 读取
    loadCardsFromLocal() {
      try {
        const data = localStorage.getItem(`savedCards_${this.agentAccount}`)
        if (data) {
          this.savedCards = JSON.parse(data)
        }
      } catch (e) {
        console.error('加载本地卡片失败:', e)
      }
    },

    // 添加自定义话术
    async addCustomPhrase() {
      const phrase = this.customPhraseInput.trim()
      if (!phrase) return
      
      try {
        const response = await apiFetch('/api/chat/phrases', {
          method: 'POST',
          body: JSON.stringify({
            agentAccount: this.agentAccount,
            content: phrase
          })
        })
        if (response.code === 0 && response.data) {
          this.phrasesCategories['自定义'].push({
            id: response.data.id,
            content: response.data.content
          })
          this.customPhraseInput = ''
        }
      } catch (e) {
        console.error('添加话术失败:', e)
      }
    },

    // 删除自定义话术
    async deleteCustomPhrase(index) {
      const phrase = this.phrasesCategories['自定义'][index]
      if (!phrase || !phrase.id) return
      
      try {
        const response = await apiFetch(`/api/chat/phrases/${phrase.id}`, {
          method: 'DELETE'
        })
        if (response.code === 0) {
          this.phrasesCategories['自定义'].splice(index, 1)
        }
      } catch (e) {
        console.error('删除话术失败:', e)
      }
    },

    // 加载自定义话术
    async loadCustomPhrases() {
      try {
        const response = await apiFetch(`/api/chat/phrases?agentAccount=${encodeURIComponent(this.agentAccount)}`)
        if (response.code === 0 && response.data) {
          this.phrasesCategories['自定义'] = response.data
        }
      } catch (e) {
        console.error('加载自定义话术失败:', e)
      }
    },

    // 更新客服在线状态（完整版，含数据库持久化，仅在上线/下线时调用）
    async updateAgentOnlineStatusFull(isOnline) {
      try {
        await apiFetch('/api/chat/online-status', {
          method: 'POST',
          body: JSON.stringify({
            username: this.agentAccount,
            userType: 'agent',
            isOnline: isOnline
          })
        })
        this.isAgentOnline = isOnline
      } catch (error) {
        console.error('更新在线状态失败:', error)
      }
    },

    // 轻量级心跳（纯内存，无数据库操作，适合高频调用）
    async sendAgentHeartbeat() {
      try {
        await apiFetch('/api/chat/heartbeat', {
          method: 'POST',
          body: JSON.stringify({ username: this.agentAccount })
        })
      } catch (error) {
        // 心跳失败静默处理
      }
    },

    // 开始会话列表轮询（WebSocket 作为主要推送方式，轮询作为备用）
    startSessionPolling() {
      this.sessionPollingInterval = setInterval(() => {
        if (!this.currentSession) {
          this.loadSessions()
        }
      }, 30000) // 降低到 30 秒，WebSocket 会实时推送状态变化
    },

    // 开始消息轮询（WebSocket 连接时作为降级备用）
    startMessagePolling() {
      // ===== 自适应轮询策略 =====
      // WebSocket 活着时拉长间隔做兜底，断了时缩短间隔
      this._msgPollTick = () => {
        const wsAlive = chatWebSocket.isConnected()
        const interval = wsAlive ? 10000 : 3000 // WS活着10秒兜底，死了3秒轮询
        this.pollNewMessages()
        this.pollingInterval = setTimeout(this._msgPollTick, interval)
      }
      this.pollingInterval = setTimeout(this._msgPollTick, 3000)

      // 已读状态：从2秒改为5秒（降低60%请求量）
      this.readStatusInterval = setInterval(() => {
        this.refreshReadStatus()
      }, 5000)
    },

    // 开始客服在线状态心跳（每2秒轻量心跳，纯内存无DB压力）
    startAgentHeartbeat() {
      this.agentHeartbeatInterval = setInterval(() => {
        this.sendAgentHeartbeat()
      }, 2000)
    },

    // 停止消息轮询
    stopMessagePolling() {
      if (this.pollingInterval) {
        clearTimeout(this.pollingInterval)
        this.pollingInterval = null
      }
      if (this.readStatusInterval) {
        clearInterval(this.readStatusInterval)
        this.readStatusInterval = null
      }
    },

    // 停止所有轮询
    stopPolling() {
      this.stopMessagePolling()
      if (this.sessionPollingInterval) {
        clearInterval(this.sessionPollingInterval)
        this.sessionPollingInterval = null
      }
      if (this.agentHeartbeatInterval) {
        clearInterval(this.agentHeartbeatInterval)
        this.agentHeartbeatInterval = null
      }
    },

    // 连接 WebSocket（订阅当前会话）
    connectWebSocket() {
      if (!this.currentSession) return

      // 只订阅会话，不重复注册消息处理器
      chatWebSocket.connect(this.currentSession.sessionKey, this.agentAccount)
        .then(() => {
          console.log('WebSocket 已订阅会话:', this.currentSession.sessionKey)
        })
        .catch(err => {
          console.log('WebSocket 订阅失败，使用轮询模式:', err)
        })
    },

    // 连接全局 WebSocket（用于接收在线状态推送和所有消息）
    connectGlobalWebSocket() {
      // 检查是否已经注册过消息处理器
      if (this.wsUnsubscribe) {
        console.log('消息处理器已注册，跳过重复注册')
        return
      }

      // 使用特殊的 sessionId 'global' 表示全局连接
      chatWebSocket.connect('global', this.agentAccount)
        .then(() => {
          console.log('全局 WebSocket 连接成功，客服账号:', this.agentAccount)
          // 只注册一次全局消息处理器
          this.wsUnsubscribe = chatWebSocket.onMessage((data) => this.handleWebSocketMessage(data))
        })
        .catch(err => {
          console.log('全局 WebSocket 连接失败:', err)
        })
    },

    // 处理 WebSocket 消息
    handleWebSocketMessage(data) {
      console.log('=== WebSocket 消息处理 ===')
      console.log('收到消息:', data)

      // 重连成功后立即补拉消息
      if (data.type === 'reconnected') {
        console.log('WebSocket 重连成功，补拉消息')
        this.pollNewMessages()
        this.refreshReadStatus()
        return
      }

      // 处理在线状态变化
      if (data.type === 'onlineStatus') {
        console.log('收到在线状态变化:', data.username, data.isOnline)
        // 更新会话列表中对应会话的在线状态
        this.sessions.forEach(session => {
          // 精确匹配：从 sessionKey 中提取 customerName（最后一个 _ 之前的部分）
          if (session.sessionKey) {
            const lastUnderscore = session.sessionKey.lastIndexOf('_')
            if (lastUnderscore > 0) {
              const sessionCustomerName = session.sessionKey.substring(0, lastUnderscore)
              if (sessionCustomerName === data.username) {
                session.isOnline = data.isOnline
              }
            }
          }
        })
        // 如果当前打开的会话匹配，也更新
        if (this.currentSession && this.currentSession.sessionKey) {
          const lastUnderscore = this.currentSession.sessionKey.lastIndexOf('_')
          if (lastUnderscore > 0) {
            const currentCustomerName = this.currentSession.sessionKey.substring(0, lastUnderscore)
            if (currentCustomerName === data.username) {
              this.currentSession.isOnline = data.isOnline
            }
          }
        }
        return
      }

      // 处理已读状态更新
      if (data.type === 'readStatusUpdate') {
        const lastReadId = data.lastReadMessageId
        const sessionKey = data.sessionKey
        // 只更新当前打开的会话
        if (this.currentSession && this.currentSession.sessionKey === sessionKey) {
          let changed = false
          const updated = this.messages.map(msg => {
            if (msg.speakerType !== 1 && msg.id <= lastReadId && !msg.isRead) {
              changed = true
              return { ...msg, isRead: true }
            }
            return msg
          })
          if (changed) this.messages = updated
        }
        return
      }

      // 处理新消息
      // 后端发送的是 sessionKey，不是 sessionId
      const msgSessionKey = data.sessionKey || data.sessionId
      console.log('当前会话:', this.currentSession?.sessionKey)
      console.log('消息会话:', msgSessionKey)

      if (data.type === 'newMessage') {
        // 更新会话列表中对应会话的最新消息（实时刷新会话列表）
        const sessionIndex = this.sessions.findIndex(s => s.sessionKey === msgSessionKey)
        if (sessionIndex !== -1) {
          const inferredCode = this.inferPlatformCodeFromCustomerName(data.customerName || this.sessions[sessionIndex].customerName)
          const incomingCode = (!data.platform || data.platform === 'xy' || data.platform === '闲鱼')
            ? inferredCode
            : data.platform
          // 使用Vue响应式方式更新 - 创建新对象替换
          const updatedSession = {
            ...this.sessions[sessionIndex],
            lastMessage: data.content,
            lastMessageTime: data.createdAt,
            platform: this.convertPlatformCode(incomingCode)
          }
          // 如果是客户消息且不是当前会话，标记为有新消息并增加未读数
          if (data.speakerType === 1 && msgSessionKey !== this.currentSession?.sessionKey) {
            updatedSession.hasNewMessage = true
            updatedSession.unreadCount = (updatedSession.unreadCount || 0) + 1
          }
          // 重新赋值触发响应式更新
          this.sessions = [
            ...this.sessions.slice(0, sessionIndex),
            updatedSession,
            ...this.sessions.slice(sessionIndex + 1)
          ]
          console.log('会话列表已更新:', msgSessionKey)
        } else if (data.customerName) {
          const inferredCode = this.inferPlatformCodeFromCustomerName(data.customerName)
          const incomingCode = (!data.platform || data.platform === 'xy' || data.platform === '闲鱼')
            ? inferredCode
            : data.platform
          // 新会话，添加到列表
          this.sessions = [{
            sessionKey: msgSessionKey,
            customerName: data.customerName,
            lastMessage: data.content,
            lastMessageTime: data.createdAt,
            isOnline: true,
            platform: this.convertPlatformCode(incomingCode),
            hasNewMessage: true,
            unreadCount: 1
          }, ...this.sessions]
          console.log('新会话已添加:', msgSessionKey)
        }

        // 如果是当前会话的消息，添加到消息列表
        if (msgSessionKey === this.currentSession?.sessionKey) {
          // 如果是客服/卖家发送的消息（speakerType !== 1），
          // 用真实ID替换乐观更新的临时ID
          if (data.speakerType !== 1) {
            // 查找乐观更新的临时消息并替换ID
            const tempIdx = this.messages.findIndex(m =>
              m.id > 1000000000000 && m.content === data.content && m.speakerType === data.speakerType
            )
            if (tempIdx !== -1 && data.id) {
              this.messages[tempIdx].id = data.id
              this.lastMessageId = Math.max(this.lastMessageId, data.id)
            }
            return
          }

          // 检查消息是否已存在
          const existingIds = new Set(this.messages.map(m => m.id))
          console.log('消息是否已存在:', existingIds.has(data.id))

          if (!existingIds.has(data.id)) {
            console.log('>>> 立即添加消息:', data.id)
            const newMessage = {
              id: data.id,
              sessionKey: msgSessionKey,
              agentAccount: data.agentAccount,
              speakerType: data.speakerType,
              content: data.content,
              customerName: data.customerName,
              createdAt: data.createdAt,
              isRead: false,
              isNew: true // 标记为新消息，播放动画
            }
            // 使用 Vue 响应式方式更新数组
            this.messages = [...this.messages, newMessage]
            this.lastMessageId = Math.max(this.lastMessageId, data.id)
            console.log('消息已添加，新长度:', this.messages.length)

            // 立即滚动到底部
            this.$nextTick(() => {
              this.scrollToBottom()
              console.log('滚动完成')
            })

            // 如果是客户消息且未免打扰，播放提示音
            if (data.speakerType === 1 && !this.isSessionMuted(msgSessionKey)) {
              this.playNotificationSound()
            }
          }
        } else if (data.speakerType === 1) {
          // 不是当前会话的客户消息，免打扰的不播放提示音
          if (!this.isSessionMuted(msgSessionKey)) {
            this.playNotificationSound()
          }
        }
      }
    },

    // 断开 WebSocket
    disconnectWebSocket() {
      if (this.wsUnsubscribe) {
        this.wsUnsubscribe()
        this.wsUnsubscribe = null
      }
      // 取消订阅当前会话
      if (this.currentSession?.sessionKey) {
        chatWebSocket.unsubscribe(this.currentSession.sessionKey)
      }
    },

    // 滚动到底部
    scrollToBottom() {
      this.$nextTick(() => {
        if (this.$refs.messagesContainer) {
          this.$refs.messagesContainer.scrollTop = this.$refs.messagesContainer.scrollHeight
        }
      })
    },

    // 播放提示音（Telegram 风格双音提示）
    playNotificationSound() {
      try {
        const audioContext = new (window.AudioContext || window.webkitAudioContext)()
        const now = audioContext.currentTime

        // 第一声 - 高音
        const osc1 = audioContext.createOscillator()
        const gain1 = audioContext.createGain()
        osc1.connect(gain1)
        gain1.connect(audioContext.destination)
        osc1.frequency.value = 880
        osc1.type = 'sine'
        gain1.gain.setValueAtTime(0.4, now)
        gain1.gain.exponentialRampToValueAtTime(0.01, now + 0.15)
        osc1.start(now)
        osc1.stop(now + 0.15)

        // 第二声 - 更高音（间隔0.12秒）
        const osc2 = audioContext.createOscillator()
        const gain2 = audioContext.createGain()
        osc2.connect(gain2)
        gain2.connect(audioContext.destination)
        osc2.frequency.value = 1175
        osc2.type = 'sine'
        gain2.gain.setValueAtTime(0.35, now + 0.12)
        gain2.gain.exponentialRampToValueAtTime(0.01, now + 0.3)
        osc2.start(now + 0.12)
        osc2.stop(now + 0.3)
      } catch (e) {
        console.log('播放提示音失败:', e)
      }
    },

    // 格式化时间
    formatTime(timeStr) {
      if (!timeStr) return ''
      const date = new Date(timeStr)
      const now = new Date()
      const diff = now - date
      
      if (diff < 60000) return '刚刚'
      if (diff < 3600000) return `${Math.floor(diff / 60000)}分钟前`
      if (diff < 86400000) return `${Math.floor(diff / 3600000)}小时前`
      
      return `${date.getMonth() + 1}/${date.getDate()}`
    },

    // 格式化消息时间
    formatMessageTime(timeStr) {
      if (!timeStr) return ''
      const date = new Date(timeStr)
      const hours = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')
      return `${hours}:${minutes}`
    },

    // 判断是否显示日期分隔符
    shouldShowDateSeparator(message, index) {
      if (index === 0) return true
      const prevMessage = this.messages[index - 1]
      if (!prevMessage) return true
      
      const currentDate = new Date(message.createdAt).toDateString()
      const prevDate = new Date(prevMessage.createdAt).toDateString()
      return currentDate !== prevDate
    },

    // 格式化日期分隔符
    formatDateSeparator(timeStr) {
      if (!timeStr) return ''
      const date = new Date(timeStr)
      const now = new Date()
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      const yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000)
      const msgDate = new Date(date.getFullYear(), date.getMonth(), date.getDate())
      
      if (msgDate.getTime() === today.getTime()) {
        return '今天'
      } else if (msgDate.getTime() === yesterday.getTime()) {
        return '昨天'
      } else {
        const month = date.getMonth() + 1
        const day = date.getDate()
        return `${month}月${day}日`
      }
    },

    // 格式化消息内容（将文字表情转回emoji显示，并进行XSS防护）
    formatContent(content) {
      if (!content) return ''
      // 先进行HTML转义，防止XSS攻击
      const escaped = escapeHtml(content)
      // 然后转换表情
      return textToEmoji(escaped)
    },

    // emoji转文字（发送时使用）
    convertEmoji(content) {
      return emojiToText(content)
    },

    // 触发图片上传
    triggerImageUpload() {
      if (this.isUploading) return
      this.$refs.imageInput?.click()
    },

    // 压缩图片
    async compressImage(file) {
      return new Promise((resolve) => {
        const reader = new FileReader()
        reader.onload = (e) => {
          const img = new Image()
          img.onload = () => {
            const canvas = document.createElement('canvas')
            let width = img.width
            let height = img.height

            // 如果图片尺寸过大，进行压缩
            const maxSize = 1920
            if (width > maxSize || height > maxSize) {
              if (width > height) {
                height = (height / width) * maxSize
                width = maxSize
              } else {
                width = (width / height) * maxSize
                height = maxSize
              }
            }

            canvas.width = width
            canvas.height = height

            const ctx = canvas.getContext('2d')
            ctx.drawImage(img, 0, 0, width, height)

            // 转换为 Blob，质量设置为 0.8
            canvas.toBlob((blob) => {
              resolve(blob)
            }, 'image/jpeg', 0.8)
          }
          img.src = e.target.result
        }
        reader.readAsDataURL(file)
      })
    },

    // 处理图片上传
    async handleImageUpload(event) {
      const file = event.target.files?.[0]
      if (!file) return

      // 检查是否是图片文件（通过MIME类型或文件扩展名）
      const isImage = file.type.startsWith('image/') ||
                     file.name.match(/\.(jpg|jpeg|png|gif|webp|heic|heif|tiff|tif|bmp|svg|ico|avif|jfif)$/i)

      if (!isImage) {
        alert('请选择图片文件')
        return
      }

      if (file.size > 10 * 1024 * 1024) {
        alert('图片大小不能超过 10MB')
        return
      }

      this.isUploading = true

      try {
        // 压缩图片（GIF和SVG除外）
        let fileToUpload = file
        if (file.type !== 'image/gif' && file.type !== 'image/svg+xml') {
          const compressedBlob = await this.compressImage(file)
          // 压缩后统一为 .jpg 扩展名，与 image/jpeg Content-Type 一致
          const compressedName = file.name.replace(/\.[^.]+$/, '.jpg')
          fileToUpload = new File([compressedBlob], compressedName, { type: 'image/jpeg' })
        }

        const formData = new FormData()
        formData.append('file', fileToUpload)

        const token = localStorage.getItem('token')
        const response = await fetch(`${API_BASE_URL}/api/chat/upload-image`, {
          method: 'POST',
          headers: token ? { 'Authorization': `Bearer ${token}` } : {},
          body: formData
        })

        const result = await response.json()

        if (result.code === 0 && result.data?.imagePath) {
          const imageContent = `[图片:${result.data.imagePath}]`
          await this.sendImageMessage(imageContent)
        } else {
          alert(result.msg || '图片上传失败')
        }
      } catch (error) {
        console.error('图片上传失败:', error)
        alert('图片上传失败，请重试')
      } finally {
        this.isUploading = false
        if (this.$refs.imageInput) {
          this.$refs.imageInput.value = ''
        }
      }
    },

    // 发送图片消息
    async sendImageMessage(imageContent) {
      if (!this.currentSession) return
      
      const tempId = Date.now()
      // 聊天室使用当前选择的身份，其他平台固定为客服(2)
      const speakerType = this.isChatRoom ? this.currentSpeakerType : 2
      const tempMessage = {
        id: tempId,
        sessionKey: this.currentSession.sessionKey,
        agentAccount: this.agentAccount,
        speakerType: speakerType,
        content: imageContent,
        customerName: this.currentSession.customerName,
        createdAt: new Date().toISOString(),
        isRead: false // 新消息默认未读
      }
      this.messages.push(tempMessage)
      this.scrollToBottom()
      
      try {
        const response = await apiFetch('/api/chat/send', {
          method: 'POST',
          body: JSON.stringify({
            sessionId: this.currentSession.sessionKey,
            agentAccount: this.agentAccount,
            speakerType: speakerType,
            content: imageContent,
            customerName: this.currentSession.customerName,
            platform: this.inferPlatformCodeFromCustomerName(this.currentSession.customerName)
          })
        })
        
        if (response.code === 0 && response.data?.messageId) {
          const msgIndex = this.messages.findIndex(m => m.id === tempId)
          if (msgIndex !== -1) {
            this.messages[msgIndex].id = response.data.messageId
          }
          this.lastMessageId = Math.max(this.lastMessageId, response.data.messageId)
        }
      } catch (error) {
        console.error('发送图片消息失败:', error)
        // 发送失败，标记消息为失败状态
        const failIdx = this.messages.findIndex(m => m.id === tempId)
        if (failIdx !== -1) {
          this.messages = [
            ...this.messages.slice(0, failIdx),
            { ...this.messages[failIdx], sendFailed: true },
            ...this.messages.slice(failIdx + 1)
          ]
        }
      }
    },

    // 判断是否是图片消息
    isImageMessage(content) {
      if (!content) return false
      const c = content.trim()
      // 支持两种格式：[图片:URL] 和 [img]URL[/img]
      return (c.startsWith('[图片:') && c.endsWith(']')) ||
             (c.includes('[img]') && c.includes('[/img]'))
    },

    // 判断是否是订单卡片消息
    isOrderMessage(content) {
      return content && content.startsWith('[订单:') && content.endsWith(']')
    },

    // 解析订单卡片消息
    parseOrderMessage(content) {
      if (!this.isOrderMessage(content)) return null
      const inner = content.slice(4, -1) // 去掉 [订单: 和 ]
      // 格式: 标题:价格:图片URL
      // 从后往前找，最后部分是图片URL(http开头)，倒数第二是价格
      const lastHttpIndex = inner.lastIndexOf(':http')
      if (lastHttpIndex === -1) {
        // 没有图片URL的情况
        const lastColon = inner.lastIndexOf(':')
        return {
          title: inner.substring(0, lastColon),
          price: inner.substring(lastColon + 1),
          image: 'https://img.alicdn.com/imgextra/i4/O1CN01Z5paLz1O0zuCC7osS_!!6000000001644-0-tps-250-250.jpg'
        }
      }
      const imageUrl = inner.substring(lastHttpIndex + 1)
      const beforeImage = inner.substring(0, lastHttpIndex)
      const lastColon = beforeImage.lastIndexOf(':')
      return {
        title: beforeImage.substring(0, lastColon),
        price: beforeImage.substring(lastColon + 1),
        image: imageUrl
      }
    },

    // 判断是否是链接卡片消息
    isLinkCardMessage(content) {
      return content && content.startsWith('[卡片:') && content.endsWith(']')
    },

    // 解析链接卡片消息
    parseLinkCardMessage(content) {
      if (!this.isLinkCardMessage(content)) return null
      const inner = content.slice(4, -1) // 去掉 [卡片: 和 ]
      // 格式: 标题:按钮文字:链接URL
      // 从后往前找 :http 分割链接
      const lastHttpIndex = inner.lastIndexOf(':http')
      if (lastHttpIndex === -1) {
        // 没有 http 开头的情况，尝试按冒号分割
        const parts = inner.split(':')
        if (parts.length >= 3) {
          const link = parts.pop()
          const btnText = parts.pop()
          return { title: parts.join(':'), btnText, link }
        }
        return { title: inner, btnText: '查看详情', link: '' }
      }
      const link = inner.substring(lastHttpIndex + 1)
      const beforeLink = inner.substring(0, lastHttpIndex)
      const lastColon = beforeLink.lastIndexOf(':')
      if (lastColon === -1) {
        return { title: beforeLink, btnText: '查看详情', link }
      }
      return {
        title: beforeLink.substring(0, lastColon),
        btnText: beforeLink.substring(lastColon + 1) || '查看详情',
        link
      }
    },


    // 获取图片URL（带XSS防护）
    getImageUrl(content) {
      if (!this.isImageMessage(content)) return ''

      let imagePath = ''
      const c = content.trim()

      // 解析 [图片:URL] 格式
      if (c.startsWith('[图片:') && c.endsWith(']')) {
        imagePath = c.slice(4, -1)
        // HTML 反转义（后端存储时可能对特殊字符做了转义）
        imagePath = imagePath
          .replace(/&#x2F;/g, '/')
          .replace(/&#x3A;/g, ':')
          .replace(/&amp;/g, '&')
          .replace(/&lt;/g, '<')
          .replace(/&gt;/g, '>')
          .replace(/&quot;/g, '"')
          .replace(/&#x27;/g, "'")
          .replace(/&#39;/g, "'")
      }
      // 解析 [img]URL[/img] 格式
      else if (c.includes('[img]') && c.includes('[/img]')) {
        const match = c.match(/\[img\](.*?)\[\/img\]/i)
        if (match && match[1]) {
          imagePath = match[1]
          // HTML 反转义
          imagePath = imagePath
            .replace(/&#x2F;/g, '/')
            .replace(/&#x3A;/g, ':')
            .replace(/&amp;/g, '&')
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>')
            .replace(/&quot;/g, '"')
            .replace(/&#x27;/g, "'")
            .replace(/&#39;/g, "'")
        }
      }

      // 验证图片路径安全性
      if (!imagePath || imagePath.includes('..') || imagePath.includes('<script')) {
        console.warn('检测到不安全的图片路径:', imagePath)
        return ''
      }

      // 如果是完整URL（OSS存储），直接返回
      if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
        return imagePath
      }

      // 否则是本地存储，拼接API路径
      const url = `${API_BASE_URL}/api/chat/image/${imagePath}`

      // 验证URL安全性
      if (!isSafeImageUrl(url)) {
        console.warn('检测到不安全的图片URL:', url)
        return ''
      }

      return url
    },

    // 预览图片（带XSS防护）
    previewImage(content) {
      const url = this.getImageUrl(content)
      if (url) {
        this.previewImageUrl = url
        this.imagePreviewVisible = true
      }
    },
    closeImagePreview() {
      this.imagePreviewVisible = false
      this.previewImageUrl = ''
    },

    // 显示图片统计
    async showImageStats() {
      try {
        const response = await apiFetch('/api/chat/image-stats')
        if (response.code === 0) {
          this.imageStats = response.data
          this.showImageModal = true
        }
      } catch (error) {
        console.error('获取图片统计失败:', error)
      }
    },

    // 清除所有图片
    async clearAllImages() {
      if (!confirm('确定要清除所有聊天图片吗？此操作不可恢复！')) {
        return
      }
      
      this.clearingImages = true
      try {
        const response = await apiFetch('/api/chat/clear-images', { method: 'DELETE' })
        if (response.code === 0) {
          alert(response.data.message)
          this.showImageModal = false
        } else {
          alert(response.msg || '清除失败')
        }
      } catch (error) {
        console.error('清除图片失败:', error)
        alert('清除图片失败')
      } finally {
        this.clearingImages = false
      }
    },

    // 置顶/取消置顶会话
    async togglePinSession() {
      if (!this.currentSession) return
      
      try {
        const response = await apiFetch('/api/chat/pinned', {
          method: 'POST',
          body: JSON.stringify({
            agentAccount: this.agentAccount,
            sessionKey: this.currentSession.sessionKey
          })
        })
        if (response.code === 0) {
          this.currentSession.isPinned = response.data.isPinned
          // 同步更新sessions列表中的状态
          const session = this.sessions.find(s => s.sessionKey === this.currentSession.sessionKey)
          if (session) {
            session.isPinned = response.data.isPinned
          }
        }
      } catch (e) {
        console.error('置顶操作失败:', e)
      }
      this.showChatSettings = false
    },

    // 从数据库加载置顶状态
    async loadPinnedSessions() {
      try {
        const response = await apiFetch(`/api/chat/pinned?agentAccount=${encodeURIComponent(this.agentAccount)}`)
        if (response.code === 0 && response.data) {
          const pinnedKeys = response.data
          this.sessions.forEach(session => {
            session.isPinned = pinnedKeys.includes(session.sessionKey)
          })
        }
      } catch (e) {
        console.log('加载置顶状态失败:', e)
      }
    },

    // 清空聊天记录
    async clearChatHistory() {
      if (!this.currentSession) return
      if (!confirm('确定要清空与该用户的所有聊天记录吗？此操作不可恢复！')) {
        return
      }
      
      try {
        const response = await apiFetch(`/api/chat/session/${encodeURIComponent(this.currentSession.sessionKey)}`, {
          method: 'DELETE'
        })
        if (response.code === 0) {
          alert(`已清空 ${response.data.deletedCount} 条聊天记录`)
          this.messages = []
          this.showChatSettings = false
          // 从会话列表中移除
          this.sessions = this.sessions.filter(s => s.sessionKey !== this.currentSession.sessionKey)
          this.closeSession()
        } else {
          alert(response.msg || '清空失败')
        }
      } catch (error) {
        console.error('清空聊天记录失败:', error)
        alert('清空聊天记录失败')
      }
    },

    // 处理返回键按下，返回 true 表示已处理，false 表示未处理
    handleBackPress() {
      // 优先关闭弹窗
      if (this.showPhrasesPanel) {
        this.closePhrasesPanel()
        return true
      }
      if (this.showNoteEditor) {
        this.showNoteEditor = false
        return true
      }
      if (this.showChatSettings) {
        this.showChatSettings = false
        return true
      }
      if (this.showImageModal) {
        this.showImageModal = false
        return true
      }

      // 如果在聊天详情页，返回到会话列表
      if (this.currentSession) {
        this.closeSession()
        return true
      }

      // 没有需要处理的，返回 false 让父组件继续处理
      return false
    }
  }
}
</script>

<style scoped>
/* ===== 聊天详情滑动动画 ===== */
.slide-chat-detail-enter-active {
  transition: transform 0.4s cubic-bezier(0.32, 0.72, 0, 1);
}

.slide-chat-detail-leave-active {
  transition: transform 0.35s cubic-bezier(0.32, 0.72, 0, 1);
}

.slide-chat-detail-enter-from,
.slide-chat-detail-leave-to {
  transform: translateX(100%);
}

/* 列表在聊天详情打开时禁用交互 */
.session-list-view.behind {
  pointer-events: none;
}

.chat-page {
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  overflow: hidden;
  position: relative;
}

/* 会话列表视图 */
.session-list-view {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.chat-header {
  padding: 14px 16px;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: saturate(180%) blur(20px);
  -webkit-backdrop-filter: saturate(180%) blur(20px);
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.08);
  display: flex;
  justify-content: center;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 10;
}

.chat-header h2 {
  margin: 0;
  font-size: 16px;
  color: #000;
  font-weight: 600;
  letter-spacing: -0.3px;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  position: absolute;
  right: 16px;
}

.clear-images-btn {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  padding: 4px;
}

/* 会话列表 */
.session-list {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-y: contain;
  touch-action: pan-y;
  /* iOS Safari 滚动修复 */
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  /* 底部留出足够空间确保最后一项不被导航栏遮挡 */
  padding-bottom: calc(70px + env(safe-area-inset-bottom, 0px));
}

.session-item {
  display: flex;
  padding: 14px 16px;
  background-color: #fff;
  cursor: pointer;
  transition: background-color 0.2s, transform 0.15s;
  align-items: center;
  border-bottom: none;
}

.session-item.pinned {
  background-color: rgba(0, 0, 0, 0.03);
}

.session-item:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

.session-item.pinned:hover {
  background-color: rgba(0, 0, 0, 0.06);
}

.session-item:active {
  background-color: rgba(0, 0, 0, 0.08);
  transform: scale(0.985);
}

.session-avatar-wrapper {
  position: relative;
  flex-shrink: 0;
}

.session-avatar {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 500;
  color: #333;
  flex-shrink: 0;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: inherit;
}

/* 在线状态点 */
.online-dot {
  position: absolute;
  bottom: 1px;
  right: 1px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #34C759;
  border: 2.5px solid #fff;
  box-shadow: 0 0 0 0.5px rgba(52, 199, 89, 0.3);
}

/* 聊天室角标 */
.chatroom-badge {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 20px;
  height: 20px;
  background: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.chatroom-badge svg {
  width: 16px;
  height: 16px;
}

.session-info {
  flex: 1;
  margin-left: 14px;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.08);
  padding: 2px 0 14px;
}

.session-item:last-child .session-info {
  border-bottom: none;
}

.session-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}

.session-name {
  font-size: 16px;
  font-weight: 600;
  color: #000;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
  letter-spacing: -0.2px;
}

.session-note-tag {
  font-size: 12px;
  color: #666;
  background: #f0f0f0;
  padding: 2px 6px;
  border-radius: 4px;
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-shrink: 0;
}

.session-time {
  font-size: 12px;
  color: #999;
  flex-shrink: 0;
  margin-left: 8px;
  font-weight: 400;
}

.session-preview {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.preview-text {
  font-size: 14px;
  color: #999;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  line-height: 1.3;
}

.preview-right {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.pin-icon {
  display: flex;
  align-items: center;
}

.pin-icon svg {
  width: 14px;
  height: 14px;
}

.unread-badge {
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  background: linear-gradient(135deg, #FF6B6B, #FF3B30);
  color: #fff;
  font-size: 11px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  box-shadow: 0 1px 4px rgba(255, 59, 48, 0.3);
}

.unread-badge.muted-badge {
  background: linear-gradient(135deg, #bbb, #999);
  box-shadow: 0 1px 4px rgba(153, 153, 153, 0.3);
}

.mute-icon {
  display: flex;
  align-items: center;
  margin-right: 4px;
  opacity: 0.6;
}

.meta-item.online {
  color: #4caf50;
}

.wifi-status {
  display: inline-flex;
  align-items: center;
  color: #ccc;
  margin-right: 5px;
  vertical-align: middle;
}

.wifi-status.online {
  color: #4caf50;
}

.wifi-status svg {
  width: 14px;
  height: 14px;
}

/* 空状态 */
.empty-state {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: #999;
}

.empty-icon {
  font-size: 60px;
  margin-bottom: 15px;
}

.empty-state p {
  margin: 0;
  font-size: 16px;
}

/* 加载状态 */
.loading-state {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #666;
  padding: 40px 20px;
}

.loading-state p {
  margin-top: 16px;
  font-size: 14px;
  color: #999;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #1890ff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.empty-hint {
  margin-top: 10px !important;
  font-size: 13px !important;
  color: #bbb;
  text-align: center;
  max-width: 250px;
}

/* 聊天详情视图 */
.chat-detail-view {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f7f7f7;
}

/* Telegram风格全屏聊天 */
.chat-detail-view.telegram-style {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100vh;
  height: 100dvh;
  z-index: 100;
  background: transparent;
  overflow: hidden;
}

/* 渐变背景Canvas */
.gradient-bg-canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  image-rendering: auto;
}

/* 背景图案层 + 轻微毛玻璃效果 */
.chat-detail-view.telegram-style::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url('@/assets/pattern.svg');
  background-size: 420px auto;
  background-repeat: repeat;
  mix-blend-mode: soft-light;
  opacity: 0.55;
  z-index: 1;
  pointer-events: none;
}

/* 确保内容在背景层之上 */
.telegram-style .detail-header,
.telegram-style .messages-container,
.telegram-style .floating-toolbar,
.telegram-style .input-area {
  position: relative;
  z-index: 2;
}

/* 顶部导航栏悬浮 */
.telegram-style .detail-header {
  position: relative;
  top: auto;
  left: auto;
  right: auto;
  z-index: 10;
  flex-shrink: 0;
}

/* 消息容器从顶部开始，留出顶部空间 */
.telegram-style .messages-container {
  padding-top: 10px;
}

/* 简洁白色头部 */
.detail-header.goofish-header {
  display: flex;
  align-items: center;
  padding: 10px 14px;
  padding-top: max(10px, env(safe-area-inset-top));
  background: #ffffff;
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.08);
  gap: 12px;
}

.gf-back {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px;
  border-radius: 50%;
  cursor: pointer;
  color: #333;
  font-size: 14px;
  font-weight: 500;
  flex-shrink: 0;
  transition: background 0.2s;
}

.gf-back:active {
  background: rgba(0, 0, 0, 0.06);
}

.gf-back svg {
  flex-shrink: 0;
}

.gf-back-count {
  font-size: 13px;
  color: #333;
}

.gf-center-info {
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

.gf-name {
  font-size: 16px;
  font-weight: 600;
  color: #000;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.gf-status {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
  margin-top: 1px;
  white-space: nowrap;
}

.gf-online {
  color: #34C759;
}

.gf-avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  justify-self: end;
  cursor: pointer;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  transition: transform 0.2s;
  will-change: transform, opacity;
}

.gf-avatar-enter {
  animation: avatarSlideIn 0.4s cubic-bezier(0.25, 1, 0.5, 1) 0.12s both;
}

@keyframes avatarSlideIn {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.gf-avatar:active {
  transform: scale(0.92);
}

.gf-avatar .avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.gf-avatar-text {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
}

/* 头部右侧操作按钮 */
.gf-header-actions {
  display: flex;
  align-items: center;
  gap: 4px;
}

.gf-action-btn {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

/* Telegram风格隐藏头像 */
.telegram-style .message-avatar {
  display: none;
}

.telegram-style .message-content {
  margin: 0;
}

.telegram-style .back-btn {
  color: #333;
}

.telegram-style .title-sub .online {
  color: #4caf50;
}

.telegram-style .platform-tag {
  background-color: rgba(0, 0, 0, 0.08);
  color: #333;
}

.telegram-style .session-xy {
  background-color: rgba(0, 0, 0, 0.06);
  color: rgba(255, 255, 255, 0.8);
}

.telegram-style .settings-btn svg path {
  fill: #666;
}

.back-btn {
  padding: 5px;
  cursor: pointer;
  color: #333;
}

.detail-title {
  flex: 1;
  margin-left: 10px;
}

.title-main {
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

.title-note {
  font-size: 13px;
  color: #888;
  font-weight: normal;
}

.title-sub {
  font-size: 12px;
  color: #999;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 2px;
}

.title-sub .online {
  color: #4caf50;
}

.platform-tag {
  background-color: #FFE60D;
  color: #333;
  padding: 1px 6px;
  border-radius: 3px;
  font-size: 11px;
}

.detail-actions {
  display: flex;
  align-items: center;
}

.session-xy {
  font-size: 11px;
  color: #999;
  background-color: #f0f0f0;
  padding: 3px 8px;
  border-radius: 4px;
}

/* 消息容器 */
.messages-container {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  padding: 15px;
  touch-action: pan-y;
}

/* Telegram风格消息容器 */
.telegram-style .messages-container {
  background: transparent !important;
  background-image: none !important;
}

/* 日期分隔符 */
.date-separator {
  display: flex;
  justify-content: center;
  margin: 15px 0;
}

.date-separator .date-text {
  background: rgba(0, 0, 0, 0.3);
  color: #fff;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

/* 消息滑入动画 */
@keyframes slideInFromLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInFromRight {
  from {
    opacity: 0;
    transform: translateX(30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.message-slide-in.customer {
  animation: slideInFromLeft 0.5s ease-out;
}

.message-slide-in.agent {
  animation: slideInFromRight 0.5s ease-out;
}

.message {
  display: flex;
  margin-bottom: 15px;
}

.message.customer {
  flex-direction: row;
}

.message.agent {
  flex-direction: row-reverse;
}

.message-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  flex-shrink: 0;
}

.customer-avatar {
  /* 背景色通过动态样式设置 */
  color: #fff;
}

.agent-avatar {
  background-color: #007AFF;
  color: #fff;
}

.message-content {
  max-width: 70%;
  margin: 0 10px;
  display: inline-block;
}

.agent-content {
  text-align: right;
}

.message-bubble {
  padding: 10px 12px;
  border-radius: 12px;
  font-size: 14px;
  line-height: 1.6;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: pre-wrap;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji', sans-serif;
  display: inline-block;
  max-width: 100%;
}

.message-bubble.customer {
  background-color: #fff;
  color: #333;
  border-top-left-radius: 4px;
}

.message-bubble.agent {
  background-color: #007AFF;
  color: #fff;
  border-top-right-radius: 4px;
  text-align: left;
}

/* Telegram风格消息气泡 */
.telegram-style .message-bubble.customer {
  background-color: #fff;
  color: #333;
  border-radius: 16px;
  border-top-left-radius: 4px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

/* === Telegram Web 风格右侧气泡 (精确对标) === */
.telegram-style .message-bubble.agent {
  background-color: #e3fee0;
  color: #000000;
  border-start-start-radius: 15px;
  border-start-end-radius: 5px;
  border-end-end-radius: 5px;
  border-end-start-radius: 15px;
  box-shadow: 0 1px 2px #10232f26;
  position: relative;
  z-index: 2;
  overflow: visible;
  padding: 0;
  min-width: 56px;
  max-width: 100%;
}

/* 气泡内文字 (对应 TG .bubble .message) */
.telegram-style .bubble-message-text {
  margin: 4px 8px 5px;
  font-size: 16px;
  line-height: 1.3125;
  color: #000000;
  word-break: break-word;
  white-space: pre-wrap;
  position: relative;
}

/* 末尾占位 */
.telegram-style .clearfix {
  display: block;
  clear: both;
}

/* 时间+勾号 (对应 TG .time) */
.telegram-style .message-bubble.agent .bubble-time {
  float: right;
  margin: 0 -2px 1px 6px;
  white-space: nowrap;
  user-select: none;
  display: inline-flex;
  align-items: center;
  gap: 2px;
  line-height: 1;
  padding-top: 4px;
}

.telegram-style .bubble-time-text {
  font-size: 12px;
  color: #5ca853;
}

/* tgico 字体图标 - Telegram 风格对勾 */
@font-face {
  font-family: 'tgico';
  src:
    url('~@/assets/fonts/tgico.woff') format('woff'),
    url('~@/assets/fonts/tgico.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: block;
}

.tgico {
  font-family: 'tgico' !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.tgico-check::before {
  content: '\e900';
}

.tgico-checks::before {
  content: '\e901';
}

/* tgico 字体勾号 */
.telegram-style .read-status {
  display: inline-block;
  vertical-align: middle;
  font-size: 16px;
  width: 18px;
  text-align: center;
  color: rgba(92, 168, 83, 0.7);
  -webkit-text-stroke: 0.5px currentColor;
  transition: all 0.3s ease-in-out;
}
.telegram-style .read-status.is-read {
  color: #5ca853;
  animation: check-to-checks 0.4s ease-in-out;
}

@keyframes check-to-checks {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.15);
    opacity: 0.85;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

/* SVG 尾巴 */
.bubble-tail {
  display: none;
}

.telegram-style .bubble-tail {
  display: block;
  position: absolute;
  right: -8.4px;
  bottom: -2px;
  width: 11px;
  height: 20px;
  fill: #e3fee0;
  transform: rotate(180deg);
}

/* 有尾巴时右下角变直角 (对标 TG .is-group-last.can-have-tail) */
.telegram-style .message-bubble.agent.has-tail {
  border-end-end-radius: 0 !important;
}

/* 尾巴需要空间不被裁剪，所有消息统一右边距保持对齐 */
.telegram-style .message.agent .agent-content {
  margin-right: 9px;
}

/* 分组圆角 (对标 TG .is-group-first) */
.telegram-style .message.agent.first-in-group .message-bubble.agent {
  border-start-end-radius: 15px;
}
.telegram-style .message.agent:not(.first-in-group) .message-bubble.agent {
  border-start-end-radius: 5px;
}

/* 买家模式 */
.telegram-style .message-bubble.buyer-mode {
  background-color: #007AFF !important;
  color: #fff !important;
}
.telegram-style .message-bubble.buyer-mode .bubble-tail {
  fill: #007AFF;
}
.telegram-style .message-bubble.buyer-mode .bubble-time-text {
  color: rgba(255, 255, 255, 0.7);
}
.telegram-style .message-bubble.buyer-mode .read-status {
  color: rgba(255, 255, 255, 0.5);
}
.telegram-style .message-bubble.buyer-mode .read-status.is-read {
  color: rgba(255, 255, 255, 0.85);
}

/* 发送失败样式 */
.telegram-style .message-bubble.send-failed {
  opacity: 0.7;
}
.telegram-style .send-failed-icon {
  cursor: pointer;
  color: #e74c3c;
  font-size: 14px;
  margin-right: 2px;
  vertical-align: middle;
}

/* 消息分组间距 (对标 TG .bubble margin) */
.telegram-style .message.agent {
  margin-bottom: 2px;
}
.telegram-style .message.agent.last-in-group {
  margin-bottom: 6px;
}

.telegram-style .message-meta {
  color: rgba(0, 0, 0, 0.4);
}

.telegram-style .message.customer .message-meta {
  color: rgba(0, 0, 0, 0.4);
}

.message-meta {
  font-size: 11px;
  color: #999;
  margin-top: 4px;
  display: flex;
  gap: 10px;
}

.agent-content .message-meta {
  justify-content: flex-end;
}

.ip-info {
  color: #bbb;
}

/* 输入区域 - 纯白底部栏，只有输入框 */
.input-area {
  background-color: #fff;
  border-top: none;
  padding: 10px 12px;
  padding-bottom: 60px; /* 为底部导航栏预留空间 */
}

/* Telegram风格输入区域 */
.telegram-style .input-area {
  position: relative;
  background: #ffffff !important;
  background-color: #ffffff !important;
  border-top: none !important;
  padding: 8px 12px;
  padding-bottom: max(28px, calc(env(safe-area-inset-bottom) + 16px));
  z-index: 2;
  flex-shrink: 0;
}

/* 悬浮工具栏 - 浮在渐变背景上，白色输入栏上方 */
.floating-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  position: relative;
  z-index: 2;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  flex-shrink: 0;
}

.floating-toolbar::-webkit-scrollbar {
  display: none;
}

/* 工具芯片按钮 */
.tool-chip {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border-radius: 20px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  color: #333;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition: background 0.2s, border-color 0.2s;
  user-select: none;
  -webkit-user-select: none;
}

.tool-chip:active {
  background: rgba(255, 255, 255, 0.95);
}

.tool-chip svg {
  flex-shrink: 0;
  color: #555;
}

.tool-chip.seller-mode {
  border-color: #ff9800;
  color: #ff9800;
}

.tool-chip.seller-mode svg {
  color: #ff9800;
}

.tool-chip.uploading {
  opacity: 0.6;
  pointer-events: none;
}

/* 消息容器底部留空 */
.telegram-style .messages-container {
  padding-bottom: 0;
}

/* 输入框 - 全宽圆角 */
.telegram-style .input-box-wrapper {
  display: flex;
  align-items: center;
  background: #f2f2f7;
  border: none;
  box-shadow: none;
  border-radius: 22px;
  padding: 4px 8px;
}

.telegram-style .message-input {
  flex: 1;
  background-color: transparent !important;
  background: transparent !important;
  border: none !important;
  border-radius: 0 !important;
  color: #333;
  padding: 10px 12px;
  font-size: 15px;
  box-shadow: none !important;
}

.telegram-style .message-input::placeholder {
  color: #999;
}

.telegram-style .message-input:focus {
  background-color: transparent !important;
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

.telegram-style .send-btn {
  background: linear-gradient(135deg, #5cb85c 0%, #4cae4c 100%);
  box-shadow: 0 2px 6px rgba(92, 184, 92, 0.4);
  border-radius: 50%;
  width: 34px;
  height: 34px;
  min-width: 34px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.telegram-style .send-btn:hover {
  box-shadow: 0 4px 12px rgba(92, 184, 92, 0.5);
}

.telegram-style .send-btn:disabled {
  background: #ccc;
  box-shadow: none;
}

.telegram-style .switch-role-btn {
  background: linear-gradient(135deg, #5cb85c 0%, #4cae4c 100%);
  box-shadow: 0 2px 6px rgba(92, 184, 92, 0.3);
  border-radius: 18px;
  padding: 6px 12px;
}

.quick-replies {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding-bottom: 10px;
  margin-bottom: 10px;
}

.quick-reply-btn {
  padding: 6px 12px;
  background-color: #f5f5f5;
  border-radius: 15px;
  font-size: 12px;
  color: #666;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 0.2s;
}

.quick-reply-btn:hover {
  background-color: #e8e8e8;
}

.input-row {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

/* 左侧工具按钮组 */
.input-tools {
  display: flex;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
}

/* 右侧输入框组 */
.input-box-wrapper {
  flex: 1;
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 8px;
}

/* 切换身份按钮 */
.switch-role-btn {
  padding: 8px 12px;
  background: linear-gradient(135deg, #007AFF 0%, #5856D6 100%);
  color: #fff;
  border: none;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  box-shadow: 0 2px 6px rgba(0, 122, 255, 0.3);
}

.switch-role-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 122, 255, 0.4);
}

.switch-role-btn.seller-mode {
  background: linear-gradient(135deg, #FF8C00 0%, #FF6B00 100%);
  box-shadow: 0 2px 6px rgba(255, 140, 0, 0.3);
}

.switch-role-btn.seller-mode:hover {
  box-shadow: 0 4px 12px rgba(255, 140, 0, 0.4);
}

.message-input {
  flex: 1;
  min-width: 0;
  padding: 10px 15px;
  border: 1px solid #e0e0e0;
  border-radius: 20px;
  font-size: 14px;
  outline: none;
  background-color: #f8f8f8;
  transition: all 0.2s ease;
}

.message-input:focus {
  border-color: #007AFF;
  background-color: #fff;
  box-shadow: 0 0 0 3px rgba(0, 122, 255, 0.1);
}

.send-btn {
  flex-shrink: 0;
  padding: 10px 18px;
  background: linear-gradient(135deg, #007AFF 0%, #5856D6 100%);
  color: #fff;
  border: none;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 6px rgba(0, 122, 255, 0.3);
}

.send-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 122, 255, 0.4);
}

.send-btn:disabled {
  background: #ccc;
  box-shadow: none;
  cursor: not-allowed;
  transform: none;
}

/* 买家模式消息气泡 */
.message-bubble.buyer-mode {
  background: linear-gradient(135deg, #FF8C00 0%, #FF6B00 100%) !important;
  position: relative;
}

.role-tag {
  display: inline-block;
  padding: 2px 6px;
  background-color: rgba(255, 255, 255, 0.25);
  border-radius: 8px;
  font-size: 10px;
  margin-right: 6px;
  vertical-align: middle;
}

/* 头部操作区 */
.header-actions {
  display: flex;
  align-items: center;
  gap: 15px;
}

.clear-images-btn {
  padding: 5px 10px;
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.clear-images-btn:hover {
  background-color: #e8e8e8;
}

/* 图片上传按钮 */
.upload-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  color: #666;
  cursor: pointer;
  transition: color 0.2s;
}

.upload-btn:hover {
  color: #007AFF;
}

.upload-btn.uploading {
  opacity: 0.6;
  cursor: not-allowed;
}

.upload-spinner {
  width: 20px;
  height: 20px;
  border: 2px solid #ddd;
  border-top-color: #007AFF;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* 图片消息样式 */
.message-image {
  max-width: 200px;
  max-height: 200px;
  min-width: 100px;
  min-height: 100px;
  border-radius: 12px;
  cursor: pointer;
  object-fit: cover;
  border: 1px solid #e0e0e0;
  background-color: #f0f0f0;
}

.message-image.agent-image {
  border-color: #007AFF;
}

/* 模态框样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background-color: #fff;
  padding: 25px;
  border-radius: 12px;
  min-width: 300px;
  max-width: 400px;
}

.modal-content h3 {
  margin: 0 0 20px 0;
  font-size: 18px;
  color: #333;
}

.image-stats {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 8px;
}

.image-stats p {
  margin: 8px 0;
  color: #666;
}

.image-stats strong {
  color: #333;
}

.modal-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

.btn-danger {
  padding: 10px 20px;
  background-color: #ff3b30;
  color: #fff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
}

.btn-danger:hover {
  background-color: #e0352c;
}

.btn-danger:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.btn-cancel {
  padding: 10px 20px;
  background-color: #f5f5f5;
  color: #666;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
}

.btn-cancel:hover {
  background-color: #e8e8e8;
}

/* 移动端响应式适配 */
@media screen and (max-width: 768px) {
  .chat-page {
    flex: 1;
  }

  .session-list-view {
    flex: 1;
  }

  .chat-detail-view {
    height: 100%;
    padding-bottom: 0;
  }

  .chat-detail-view.telegram-style {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100vh;
    height: 100dvh;
  }

  .chat-header {
    padding: 10px 16px;
    position: sticky;
    top: 0;
    z-index: 10;
  }

  .chat-header h2 {
    font-size: 15px;
  }

  .session-list {
    flex: 1;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .session-item {
    padding: 12px 16px;
  }

  .session-avatar {
    width: 48px;
    height: 48px;
    font-size: 12px;
  }

  .online-dot {
    width: 11px;
    height: 11px;
    border-width: 2px;
  }

  .session-name {
    font-size: 15px;
  }

  .preview-text {
    font-size: 13px;
  }

  .detail-header {
    position: sticky;
    top: 0;
    z-index: 10;
    padding: 8px 12px;
  }

  .messages-container {
    flex: 1;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding: 10px;
    padding-bottom: 20px;
  }

  .message-content {
    max-width: 80%;
  }

  .message-bubble {
    padding: 8px 10px;
    font-size: 14px;
  }

  .input-area {
    padding: 8px 10px;
    padding-bottom: 60px; /* 底部导航栏 */
    position: sticky;
    bottom: 0;
    background-color: #fff;
  }

  .telegram-style .input-area {
    padding: 8px 10px;
    padding-bottom: max(10px, env(safe-area-inset-bottom));
    position: relative;
    background: #ffffff !important;
  }

  .tool-chip {
    padding: 7px 14px;
    font-size: 13px;
  }

  .floating-toolbar {
    padding: 6px 10px;
    gap: 6px;
  }

  .quick-replies {
    display: flex;
    gap: 6px;
    padding-bottom: 8px;
    margin-bottom: 8px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .quick-replies::-webkit-scrollbar {
    display: none;
  }

  .quick-reply-btn {
    padding: 5px 10px;
    font-size: 11px;
    flex-shrink: 0;
  }

  .input-row {
    gap: 8px;
  }

  .upload-btn {
    width: 36px;
    height: 36px;
  }

  .message-input {
    padding: 8px 12px;
    font-size: 14px;
  }

  .send-btn {
    padding: 8px 15px;
    font-size: 13px;
  }

  .message-image {
    max-width: 150px;
    max-height: 150px;
  }

  .modal-content {
    margin: 15px;
    min-width: auto;
    width: calc(100% - 30px);
    max-width: 350px;
  }

  .header-actions {
    gap: 10px;
  }

  .clear-images-btn {
    padding: 4px 8px;
    font-size: 11px;
  }
}

/* 聊天设置弹窗 */
.settings-btn {
  cursor: pointer;
  padding: 5px;
  margin-left: 10px;
  display: flex;
  align-items: center;
}

.settings-btn:hover svg path {
  fill: #333;
}

.chat-settings-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  z-index: 1000;
}

/* 设置弹窗动画 */
.settings-popup-enter-active {
  transition: background-color 0.25s ease;
}
.settings-popup-enter-active .chat-settings-panel,
.settings-popup-enter-active .note-editor-panel {
  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}
.settings-popup-leave-active {
  transition: background-color 0.2s ease;
}
.settings-popup-leave-active .chat-settings-panel,
.settings-popup-leave-active .note-editor-panel {
  transition: transform 0.2s cubic-bezier(0.4, 0, 1, 1);
}
.settings-popup-enter-from {
  background-color: rgba(0, 0, 0, 0) !important;
}
.settings-popup-enter-from .chat-settings-panel,
.settings-popup-enter-from .note-editor-panel {
  transform: translateY(100%);
}
.settings-popup-leave-to {
  background-color: rgba(0, 0, 0, 0) !important;
}
.settings-popup-leave-to .chat-settings-panel,
.settings-popup-leave-to .note-editor-panel {
  transform: translateY(100%);
}

.chat-settings-panel {
  width: 100%;
  max-width: 500px;
  padding: 0 10px 10px;
}

.settings-list {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.settings-item {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 14px 0;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  font-size: 15px;
  color: #333;
}

.settings-item:first-child {
  border-radius: 12px 12px 0 0;
}

.settings-item.settings-cancel {
  border-radius: 12px;
  margin-top: 8px;
  font-weight: 500;
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
}

.settings-item:active {
  background: rgba(230, 230, 230, 0.75);
}

/* 清空聊天记录前面的最后一项圆角 */
.settings-item:nth-last-child(2) {
  border-radius: 0 0 12px 12px;
}

/* 备注编辑器 */
.note-editor-panel {
  background: #fff;
  width: 100%;
  max-width: 500px;
  border-radius: 16px 16px 0 0;
  overflow: hidden;
}

.note-editor-body {
  padding: 16px;
}

.note-textarea {
  width: 100%;
  height: 120px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 12px;
  font-size: 14px;
  resize: none;
  outline: none;
}

.note-textarea:focus {
  border-color: #007AFF;
}

.note-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
}

.note-count {
  font-size: 12px;
  color: #999;
}

.note-save-btn {
  padding: 8px 24px;
  background: #007AFF;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
}

.note-save-btn:hover {
  background: #0066CC;
}

/* 针对小屏幕手机的额外适配 */
@media screen and (max-width: 375px) {
  .chat-header h2 {
    font-size: 15px;
  }

  .session-avatar {
    width: 40px;
    height: 40px;
    font-size: 11px;
  }

  .session-info {
    margin-left: 10px;
  }

  .session-name {
    font-size: 13px;
  }

  .preview-text {
    font-size: 12px;
  }

  .message-avatar {
    width: 35px;
    height: 35px;
    font-size: 10px;
  }

  .message-content {
    margin: 0 8px;
  }

  .quick-reply-btn {
    padding: 4px 8px;
    font-size: 10px;
  }
}

/* 防止iOS上键盘弹出时页面上推 */
@supports (-webkit-touch-callout: none) {
  .chat-page {
    height: -webkit-fill-available;
  }
  
  .chat-detail-view {
    height: 100%;
    min-height: -webkit-fill-available;
  }
}

/* 话术按钮 */
.phrases-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  color: #666;
  background: none;
  border: none;
  cursor: pointer;
  transition: color 0.2s;
  padding: 0;
}

.phrases-btn:hover {
  color: #007AFF;
}

/* 话术面板遮罩 */
.phrases-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100vh;
  height: 100dvh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.25s ease-out;
}

/* 遮罩层淡入动画 */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* 遮罩层淡出动画 */
@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.phrases-overlay.closing {
  animation: fadeOut 0.25s ease-in;
}

/* 话术面板 */
.phrases-panel {
  background: #fff;
  width: 100%;
  max-width: 500px;
  max-height: 60vh;
  border-radius: 16px 16px 0 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: slideUpIn 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  transform-origin: bottom;
}

/* 话术面板滑入动画 */
@keyframes slideUpIn {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* 话术面板滑出动画 */
@keyframes slideDownOut {
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(100%);
    opacity: 0;
  }
}

.phrases-panel.closing {
  animation: slideDownOut 0.25s cubic-bezier(0.55, 0.055, 0.675, 0.19);
}

.phrases-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
  font-size: 16px;
  font-weight: 500;
}

.phrases-header .close-btn {
  font-size: 24px;
  color: #999;
  cursor: pointer;
  line-height: 1;
}

/* 话术分类标签 */
.phrases-tabs {
  display: flex;
  padding: 10px 15px;
  gap: 10px;
  border-bottom: 1px solid #eee;
  background: #fafafa;
}

.phrases-tab {
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 13px;
  color: #666;
  background: #fff;
  border: 1px solid #e0e0e0;
  cursor: pointer;
  transition: all 0.2s;
}

.phrases-tab:hover {
  border-color: #007AFF;
  color: #007AFF;
}

.phrases-tab.active {
  background: #007AFF;
  color: #fff;
  border-color: #007AFF;
}

/* 自定义话术输入区域 */
.custom-phrase-input {
  display: flex;
  gap: 10px;
  padding: 12px 15px;
  border-bottom: 1px solid #eee;
}

.custom-phrase-input input {
  flex: 1;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
}

.custom-phrase-input input:focus {
  border-color: #2196F3;
}

.custom-phrase-input button {
  padding: 8px 16px;
  background: #2196F3;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
}

.custom-phrase-input button:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.empty-phrases {
  padding: 30px 20px;
  text-align: center;
  color: #999;
  font-size: 14px;
}

.phrases-list {
  flex: 1;
  overflow-y: auto;
  padding: 10px 0;
}

.phrase-item {
  padding: 14px 20px;
  cursor: pointer;
  transition: background 0.2s;
  font-size: 14px;
  color: #333;
  border-bottom: 1px solid #f5f5f5;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.phrase-item span:first-child {
  flex: 1;
}

.delete-phrase {
  color: #ff3b30;
  font-size: 18px;
  font-weight: bold;
  padding: 0 5px;
  cursor: pointer;
}

.phrase-item:hover {
  background: #f5f5f5;
}

.phrase-item:active {
  background: #eee;
}

.phrase-item:last-child {
  border-bottom: none;
}

/* 卡片面板样式 */
.card-add-area {
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-bottom: 1px solid #f0f0f0;
}

.card-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.2s;
}

.card-input:focus {
  border-color: #007aff;
}

.card-save-btn {
  align-self: flex-end;
  padding: 8px 24px;
  background: #007aff;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: opacity 0.2s;
}

.card-save-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.card-save-btn:not(:disabled):active {
  opacity: 0.8;
}

.card-item {
  padding: 12px 16px;
  cursor: pointer;
  transition: background 0.2s;
  border-bottom: 1px solid #f5f5f5;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-item:hover {
  background: #f5f5f5;
}

.card-item:active {
  background: #eee;
}

.card-item:last-child {
  border-bottom: none;
}

.card-item-content {
  flex: 1;
  min-width: 0;
}

.card-item-title {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.card-item-btn-text {
  font-size: 12px;
  color: #007aff;
  font-weight: 500;
}

/* 移动端话术按钮适配 */
@media screen and (max-width: 768px) {
  .phrases-btn {
    width: 36px;
    height: 36px;
  }
  
  .phrases-panel {
    max-height: 50vh;
  }
  
  .phrases-tabs {
    padding: 8px 12px;
    gap: 8px;
  }
  
  .phrases-tab {
    padding: 6px 12px;
    font-size: 12px;
  }
  
  .phrase-item {
    padding: 12px 16px;
    font-size: 13px;
  }
}

/* 图片预览模态框 */
.image-preview-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  display: none;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.image-preview-modal.active {
  display: flex;
}
.image-preview-content {
  max-width: 90%;
  max-height: 90%;
  object-fit: contain;
}

/* 订单卡片消息样式 */
.order-card-msg {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  max-width: 260px;
}
.agent-order-card {
  margin-left: auto;
}
.order-card-inner {
  display: flex;
  font-size: 0.875rem;
  padding: 0.75rem;
  min-height: 96px;
}
.order-card-img {
  width: 80px;
  height: 80px;
  border-radius: 6px;
  object-fit: cover;
  flex-shrink: 0;
  margin-right: 10px;
}
.order-card-body {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}
.order-card-detail {
  display: flex;
  flex: 1;
}
.order-card-name {
  flex: 1;
  font-size: 0.875rem;
  font-weight: 400;
  color: #111;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4;
}
.order-card-price-wrap {
  flex-shrink: 0;
  text-align: right;
  margin-left: 8px;
}
.order-card-currency {
  font-size: 0.75rem;
  color: #111;
}
.order-card-price {
  font-size: 1rem;
  font-weight: 600;
  color: #111;
}
.order-card-count {
  display: block;
  font-size: 0.75rem;
  color: #999;
  margin-top: 2px;
}
.order-card-status {
  font-size: 0.75rem;
  color: #ff5000;
  margin-top: auto;
}

/* 链接卡片消息样式（类似订单卡片，无图片） */
.link-card-msg {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  max-width: 260px;
}
.agent-link-card {
  margin-left: auto;
}
.link-card-inner {
  padding: 0.75rem;
}
.link-card-title {
  font-size: 0.875rem;
  font-weight: 500;
  color: #111;
  margin: 0 0 10px 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.link-card-btn {
  display: block;
  width: 100%;
  padding: 8px 0;
  text-align: center;
  background: #007aff;
  color: #fff;
  font-size: 0.8125rem;
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
  transition: opacity 0.2s;
}
.link-card-btn:active {
  opacity: 0.8;
}

/* ========================================
   桌面端四栏布局样式
   ======================================== */

/* 桌面模式下 .chat-page 改为横向排列 */
.chat-page.chat-desktop-mode {
  flex-direction: row;
  height: 100%;
  width: 100%;
}

/* 桌面模式下会话列表固定宽度 */
.chat-desktop-mode .session-list-view {
  width: 320px;
  min-width: 260px;
  max-width: 360px;
  height: 100%;
  border-right: 1px solid rgba(0, 0, 0, 0.08);
  flex-shrink: 0;
}

.chat-desktop-mode .session-list-view.behind {
  pointer-events: auto;
}

.chat-desktop-mode .session-list {
  padding-bottom: 10px;
}

/* 桌面模式下聊天详情不再用 fixed 覆盖，覆盖 .telegram-style 的定位 */
.chat-detail-view.desktop-detail {
  position: relative !important;
  top: auto !important;
  left: auto !important;
  right: auto !important;
  bottom: auto !important;
  width: auto !important;
  height: 100% !important;
  flex: 1;
  min-width: 0;
  z-index: 1 !important;
}

/* 桌面模式下也需要渐变背景和图案（继承自 telegram-style，无需重复） */

/* 桌面模式下头部、消息、工具栏、输入区 z-index 确保在背景上层 */
.desktop-detail .detail-header,
.desktop-detail .messages-container,
.desktop-detail .floating-toolbar,
.desktop-detail .input-area {
  position: relative;
  z-index: 2;
}

/* 桌面模式下消息容器 */
.chat-desktop-mode .messages-container {
  flex: 1;
  background: transparent !important;
  padding-top: 10px;
}

/* 桌面模式下输入区域 */
.chat-desktop-mode .input-area {
  position: relative;
  z-index: 2;
  padding: 8px 16px !important;
  padding-bottom: 10px !important;
  background: #fff !important;
}

.chat-desktop-mode .floating-toolbar {
  position: relative;
  z-index: 2;
}

/* 桌面模式下返回按钮的未读数移到左边 */
.chat-desktop-mode .gf-back {
  display: flex;
  align-items: center;
  cursor: pointer;
}

/* 桌面模式下选中会话高亮 */
.chat-desktop-mode .session-item.desktop-active {
  background-color: rgba(0, 122, 255, 0.08);
}

/* ========== 桌面端常驻话术侧栏 ========== */
.desktop-phrases-sidebar {
  width: 260px;
  min-width: 220px;
  max-width: 300px;
  height: 100%;
  border-left: 1px solid rgba(0, 0, 0, 0.08);
  background: #fff;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex-shrink: 0;
}

.desktop-phrases-sidebar .phrases-header {
  padding: 16px;
  font-size: 15px;
  font-weight: 600;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.desktop-phrases-sidebar .phrases-tabs {
  display: flex;
  flex-wrap: wrap;
  padding: 8px 12px;
  gap: 6px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
}

.desktop-phrases-sidebar .phrases-tab {
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  background: #f0f0f0;
  cursor: pointer;
  transition: all 0.15s;
  color: #666;
}

.desktop-phrases-sidebar .phrases-tab.active {
  background: #007AFF;
  color: #fff;
}

.desktop-phrases-sidebar .phrases-tab:hover:not(.active) {
  background: #e4e4e4;
}

.desktop-phrases-sidebar .custom-phrase-input {
  display: flex;
  padding: 8px 12px;
  gap: 8px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
}

.desktop-phrases-sidebar .custom-phrase-input input {
  flex: 1;
  padding: 6px 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 13px;
  outline: none;
}

.desktop-phrases-sidebar .custom-phrase-input input:focus {
  border-color: #007AFF;
}

.desktop-phrases-sidebar .custom-phrase-input button {
  padding: 6px 14px;
  background: #007AFF;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  cursor: pointer;
}

.desktop-phrases-sidebar .custom-phrase-input button:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.desktop-phrases-sidebar .phrases-list {
  flex: 1;
  overflow-y: auto;
  padding: 4px 0;
}

.desktop-phrases-sidebar .phrase-item {
  padding: 10px 16px;
  font-size: 13px;
  color: #333;
  cursor: pointer;
  transition: background 0.15s;
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 1.4;
  border-bottom: 1px solid rgba(0, 0, 0, 0.03);
}

.desktop-phrases-sidebar .phrase-item:hover {
  background: #f5f7fa;
}

.desktop-phrases-sidebar .phrase-item:active {
  background: #e8ecf1;
}

.desktop-phrases-sidebar .delete-phrase {
  color: #ff4d4f;
  cursor: pointer;
  font-size: 16px;
  padding: 0 4px;
  flex-shrink: 0;
  opacity: 0;
  transition: opacity 0.15s;
}

.desktop-phrases-sidebar .phrase-item:hover .delete-phrase {
  opacity: 1;
}

.desktop-phrases-sidebar .empty-phrases {
  text-align: center;
  color: #999;
  padding: 20px;
  font-size: 13px;
}

/* 桌面端无会话占位 */
.desktop-no-session {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f2f5;
  min-width: 0;
}

.no-session-content {
  text-align: center;
  color: #999;
}

.no-session-content p {
  margin-top: 16px;
  font-size: 15px;
}

</style>
